import { DatePipe } from '@angular/common';
import { Component, Input, OnInit, OnDestroy, EventEmitter, Output } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { saveAs as saveByFileSaver } from "file-saver";
import { ConfirmationService, SelectItem, SortEvent } from 'primeng/api';
import { APGTestingService } from '../agptesting-newview/apgtesting.service';
import { APGCovid19Constants, colorMap } from '../agptesting-newview/model/apg-newview-constants';
import { Channel } from '../agptesting-newview/model/channel';
import { ChannelTestingTypeMapping } from '../agptesting-newview/model/channel-testing-type-mapping';
import { CovidSamples, MutationCoverage, MutationInfo } from '../agptesting-newview/model/covid-sample';
import { Covid19Batch, FilesPerManufacturer, WellType } from '../agptesting-newview/model/covid19Batch';
import { ManualQCReviewRequest } from '../agptesting-newview/model/manual-qc-review-request';
import { MergedBatch } from '../agptesting-newview/model/merged-batch';
import { Quadrant } from '../agptesting-newview/model/quadrant';
import { ResultMapper } from '../agptesting-newview/model/result-mapper';
import { ResultMapperMetricsMerged } from '../agptesting-newview/model/result-mapper-metrics';
import { ResultMapperRead } from '../agptesting-newview/model/result-read';
import { MasterDataService } from '../masterdata/masterdata.service';
import { MessagesService } from '../messages/messages.service';
import { NumberFormatPipe } from '../pipes/number.pipe';
import { ErrorHandler } from '../utils/error-handler';
import { ResultPangolianMapper } from '../agptesting-newview/model/ResultPangolianMapper';
import { PangolianPieModel } from '../agptesting-newview/model/pangolian-pie-data';
import { BatchQCView } from '../agptesting-newview/model/batch-qc-view';


@Component({
  selector: 'app-plate-view',
  templateUrl: './plate-view.component.html',
  styleUrls: ['./plate-view.component.css']
})
export class PlateViewComponent implements OnInit, OnDestroy {

  
  mapOfQCBatchView = new Map();
  @Input() selectedBatch: Covid19Batch;
  @Input() puid: string;
  @Input() selectedLabId: string;
  @Input() totalPCRControls: number;
  @Input() showPlateView: boolean;
  @Input() viewMode: string;
  @Input() sourceBatchSamplesMap: Map<string, CovidSamples[]>;
  
  qcPassed: string;
  qcMergeCount: string;
  qcReadCount: string;

  blocked = false;
  errorHandler: ErrorHandler = new ErrorHandler;
  plateMap = new Map();
  sampleBatch1Map = new Map();
  sampleBatch2Map = new Map();
  sampleBatch3Map = new Map();
  sampleBatch4Map = new Map();
  val2: string;
  plateViewData: CovidSamples[] = [];
  plateOne: string;
  plateTwo: string;
  plateThree: string;
  plateFour: string;
  batchQCView: BatchQCView[] = [];
  sampleBatch1: CovidSamples[] = [];
  sampleBatch2: CovidSamples[] = [];
  sampleBatch3: CovidSamples[] = [];
  sampleBatch4: CovidSamples[] = [];
  sampleBatch1PosControlsPositions: string[] = [];
  sampleBatch2PosControlsPositions: string[] = [];
  sampleBatch3PosControlsPositions: string[] = [];
  sampleBatch4PosControlsPositions: string[] = [];
  sampleBatch1PosControlsPositionsturned: string[] = [];
  sampleBatch2PosControlsPositionsturned: string[] = [];
  sampleBatch3PosControlsPositionsturned: string[] = [];
  sampleBatch4PosControlsPositionsturned: string[] = [];
  backGroundColor: string;
  circleBorder: string;
  crossWidth: string;
  crossColor: string;
  circleStroke: string;
  scanAllowedStates = ['SCAN_COMPLETE', 'START_CLIPPING', 'COMPLETE_CLIPPING'];
  counter: number;
  color: string;
  manufacturerConfigMap = new Map<string, any>();
  fileTypeCountMap = new Map<string, number>();
  manufacturerFileMandatoryMap = new Map<string, any>();
  filesPerManufacturerMap = new Map<string, FilesPerManufacturer[]>();
  missingFilesPopUp: boolean = false;
  missingPatterns: any[];
  myFiles: string[] = [];
  readonly emptyGeneName = 'Empty';
  gene: string = this.emptyGeneName;
  mapOfKits = new Map();
  machineIOCapcity = new Map<string, string>();
  boxColor: string;
  redoReasonsPopup: boolean = false;
  selectedRedoReason: string;
  enteredRedoReason: string;
  selectedMergedBatch: MergedBatch;
  redoReasons: any[];
  bioRadMachineTypes = ["biorad", "biorad_dk"];
  mapOfMachineInfo = new Map<string, any>();
  machineShortInfos = new Map<string, string>();
  ixoFiles: string[] = [];
  isResultUploadDisabled: boolean = true;
  missingBarcodesList: string[];
  samplePopVisible = false;
  selectedSample: CovidSamples = new CovidSamples();
  isResultGroup: boolean = false;
  resultGroupMap: Map<string, any> = new Map<string, any>();
  samplePosition = '';
  sampleType = '';
  tempSampleComment: string;
  tempSampleInvalid: boolean;
  tempSampleResult: string;
  tempICRResult: boolean;
  sampleResultOptions: SelectItem[] = [];
  sampleResultOptionsWithoutPositive: SelectItem[] = [];
  icrPresentInKit = false;
  scanDialogMessage = 'Scan RNA Plate changes not yet saved. Do you wish to proceed?';
  redoDialogMessage = 'Are you are sure to do the redo?';
  changedSampleList: CovidSamples[] = [];
  showAnalysisDialog = false;
  columnList: any[] = [];
  analysisVerifyPUID: string = null;
  commentPopup = false;
  enteredPuid: string;
  enteredPassword: string;
  enteredPasswordToByeArray: any[];
  mapOfScannedBarcodes: Map<string, string>;
  scanTableBackupMap: Map<string, CovidSamples>;
  currentScanCell = 0;
  posControlsForLab: number;
  negativeControlForLab: number;
  posControlsRemaining: number;
  negativeControlRemaining: number;
  scanTableArray: CovidSamples[] = [];
  scannedControls: CovidSamples[] = [];
  activateSaveScan = false;
  contaminationPopUp = false;
  scannedBarcode = '';
  showDifferentUnboxedErrorPopUp = false;
  differentUnboxedErrorDisabled = false;
  showSampleErrorPopUp = false;
  scannedSampleErrorMessage = '';
  dirty = false;
  scanBlock = false;
  sameScanBatch = false;
  saveScanErrorHeader = '';
  saveScanErrorBody = '';
  icrResultOptionsNormal = [
    { value: true, label: 'Positive' },
    { value: false, label: 'Negative' }
  ];
  icrResultOptionsNegative = [
    { value: true, label: 'Negative' },
    { value: false, label: 'Positive' }
  ];
  positiveControlResultOptions = [
    { value: 'positive', label: 'Passed' },
    { value: 'negative', label: 'Failed' },
    { value: 'check', label: 'Check' },
    { value: 'ambiguous', label: 'Ambiguous' },
    { value: 'invalid', label: 'Invalid' }
  ];
  resultGroupControlResultOptions = [
    { value: 'positive', label: 'Positive' },
    { value: 'negative', label: 'Negative' },
    { value: 'check', label: 'Check' },
    { value: 'ambiguous', label: 'Ambiguous' },
    { value: 'invalid', label: 'Invalid' },
    { value: 'retest', label: 'Retest' },
  ];
  negativeControlResultOptions = [
    { value: 'positive', label: 'Failed' },
    { value: 'negative', label: 'Passed' },
    { value: 'check', label: 'Check' },
    { value: 'ambiguous', label: 'Ambiguous' },
    { value: 'invalid', label: 'Invalid' }
  ];
  uploadedTxtFiles: string[] = [];
  uploadedxlsxFiles: string[] = [];
  uploadedPCRDFiles: string[] = [];
  uploadedXMLFiles: string[] = [];
  uploadedCSVFiles: string[] = [];
  bioradLimsFiletypes: Array<string> = ['xlsx', 'pcrd', 'ixo', 'csv'];
  fastFinderFiletypes: Array<string> = ['xlsx', 'pcrd', 'ixo', 'csv'];
  filetypes: Array<string> = ['ixo', 'txt', 'xml', 'csv'];
  allChecksResolved = true;
  dominantChannelName: string;
  colorSenderMap = new Map();
  colours = ['#ffb3b3', '#9999e6', '#ff80ff', '#a6a6a6', '#ff5050', '#33cccc', '#80ff80', '#ffaa00', '#0099ff', '#888844'];
  reportingOutsideBB = true;
  finalStatusList = [
    { label: 'Report', value: 'Report' },
    { label: 'Redo PCR', value: 'Redo_PCR' },
    { label: 'Redo Lysis', value: 'Redo_Lysis' },
    { label: 'Check', value: 'Check' }
  ];

  finalStatusListWithoutLysis = [
    { label: 'Report', value: 'Report' },
    { label: 'Redo PCR', value: 'Redo_PCR' },
    { label: 'Check', value: 'Check' }
  ];
  columnHeaders = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
  rowHeaders = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H'];

  columnHeaders384 = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24];
  rowHeaders384 = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P'];

  columnHeaders96Odd = [1, 3, 5, 7, 9, 11, 13, 15, 17, 19, 21, 23];
  rowHeaders96Odd = ['A', 'C', 'E', 'G', 'I', 'K', 'M', 'O'];

  columnHeaders96Even = [2, 4, 6, 8, 10, 12, 14, 16, 18, 20, 22, 24];
  rowHeaders96Even = ['B', 'D', 'F', 'H', 'J', 'L', 'N', 'P'];

  controlArray = ['POS_EX', 'NTC_EX', 'PCR-PC', 'PCR-NTC'];
  sampleHistoryMap: any;
  batchHeaders: string[] = [];
  selectedSampleHistoryMap: Map<string, Object> = null;

  reset: any[] = [{}];

  headerIndex = 0;
  analysisAndUpwardsStatuses = ['ANALYSIS_STARTED', 'ANALYSIS_DONE', 'REDO', 'DATA_READY', 'COMPLETED'];
  subSender = new Set();
  subSenderForPlateOne = new Set();
  subSenderForPlateTwo = new Set();
  subSenderForPlateThree = new Set();
  subSenderForPlateFour = new Set();
  analysisPlateView: boolean = false;
  htmlfileName: string;
  manualQCReviewMode: boolean = false;
  manualQCReviewMode2: boolean = false;
  mapOfQCReviewsForNumberReads = new Map();
  mapOfQCReviewsForMetricsMerged = new Map();
  pangolianTextFileName: string;
  pangolianPieData :Map<string, PangolianPieModel> = new Map<string, PangolianPieModel>();
  pangolianPieColorMap :Map<string, string> = new Map<string, string>();
  colorScheme = {
  domain: ['#FFFF00', '#40E0D0', '#9ACD32', '#F5DEB3', '#FF6347', '#D8BFD8', '#008080', '#00FF7F', '#4682B4', '#708090', '#87CEEB', 
          '#FFF5EE', '#2E8B57', '#F4A460', '#FA8072', '#8B4513', '#663399', '#B0E0E6', '#FFC0CB', '#DB7093', '#98FB98', '#EEE8AA',
          '#DA70D6', '#FFA500', '#6B8E23', '#000080', '#C71585', '#48D1CC', '#00FA9A', '#FF00FF', '#32CD32', '#00FF00', '#20B2AA',
          '#FFA07A', '#FAFAD2', '#E0FFFF', '#F08080', '#FFFFF0', '#DAA520', '#FFD700', '#B22222', '#696969', '#FF1493', '#2F4F4F', 
          '#FF8C00', '#556B2F', '#B8860B', '#DC143C', '#00FFFF', '#D2691E', '#7FFF00', '#8A2BE2', '#F5F5DC', '#F0FFFF', '#7FFFD4', 
          '#FAEBD7', '#F0F8FF', '#FFFACD', '#FFDAB9', '#8FBC8F', '#483D8B', '#BA55D3', '#DDA0DD', '#BC8F8F', '#DDBA93', '#F4998C',
          '#F5F4AC', '#FBF80E', '#9E9C1D', '#E5F9C0', '#96BC4E', '#F5FBF6', '#6D8370', '#61FE77', '#ADD8C5', '#05F58C', '#06A35E',
          '#EDF8F7', '#A6CDC9', '#66FDED', '#92DEF6', '#B7D2DA', '#B6C5CA', '#F8C5E6', '#F591D2', '#BD077D', '#F15B98', '#F8C471',
          '#566573', '#F8F8FF', '#F5FFFA', '#FFFAFA', '#F1A6F7', '#9F90A0', '#7C79C1', '#7D9F84']
  };
  pangoliandata: PangolianPieModel[]=[];
  mutationRecentDate: Date;
  mutationRunId: string;
  mutationProcessedData :Map<string,number>=new Map<string,number>();
  variantFilesProcessed:string;
  previousRadioValue :string = "Read Counts";

  mapRowAdder = new Map();
  mapColAdder = new Map();

  quadrantBatchMap = new Map();
  quadrantList = ["A1", "A2", "B1", "B2"];

  mapOfA1 = new Map();
  mapOfA2 = new Map();
  mapOfB1 = new Map();
  mapOfB2 = new Map();

  @Output() valueChange = new EventEmitter();

  snpProfileThresholdValue: number;
  snpProfileName: string;

  sampleBarcodeName:string;

  customColors = (value) => {
    if(this.pangolianPieColorMap.has(value)){
      return this.pangolianPieColorMap.get(value);
    }
  }

  constructor(private _messagesService: MessagesService, private apgTestingService: APGTestingService, private formBuilder: FormBuilder, private confirmationService: ConfirmationService, private masterDataService: MasterDataService, public datepipe: DatePipe, private numberFormatPipe: NumberFormatPipe) { }
  ngOnDestroy(): void {
    this.manualQCReviewMode = false;
    this.manualQCReviewMode2 = false;
    if(Array.from(this.mapOfQCReviewsForNumberReads.keys()).length > 0 || Array.from(this.mapOfQCReviewsForMetricsMerged.keys()).length > 0){
        this.onManualQCReviewClicked(this.mapOfQCReviewsForNumberReads, 'numberReads');
        this.onManualQCReviewClicked(this.mapOfQCReviewsForMetricsMerged, 'metricsMerged');
        this.valueChange.emit({"dirtyChild":false});
    }
  }

  ngOnInit() {
    if(this.viewMode == 'MIDPLEX_PLATE_VIEW_MODE') {
      this.constructMidplexPlateMaps();
    } else if(this.viewMode == 'ARTIC_PLATE_VIEW_MODE') {
      this.fetchDataForPlateView();
    }
  }

  fetchDataForPlateView() {
    this.createPlateMaps(this.selectedBatch.samples);
    if (this.selectedBatch.resultsImported) {
      this.getAnalysisView();
      this.analysisPlateView = true;
      this.htmlfileName=this.getSecondaryAnalysisFileName(this.selectedBatch.secondaryAnalysisHtmlPath);
      if(this.selectedBatch.pangolianResultsImportedDateTime){
      this.getColorsMap();
      this.getPangolianPieChartData();
      this.pangolianTextFileName=this.getSecondaryAnalysisFileName(this.selectedBatch.pangolianTextFilePath);
      this.getProcessedFilesData();
      }
    }
    else
      this.val2 = this.selectedBatch.measuredLibQCDateTime ? 'Library' : this.selectedBatch.measuredArticQCDateTime ? 'Artic' : 'Detail';
    if (this.selectedBatch.samples && this.selectedBatch.samples.length > 0) {
      this.getSubSenders();
    }
  }

  createPlateMaps(data: any) {

    this.plateOne = undefined;
    this.plateTwo = undefined;
    this.plateThree = undefined;
    this.plateFour = undefined;
    this.plateViewData = data;
    this.plateMap = new Map();
    this.sampleBatch1Map = new Map();
    this.sampleBatch2Map = new Map();
    this.sampleBatch3Map = new Map();
    this.sampleBatch4Map = new Map();
    this.sampleBatch1 = [];
    this.sampleBatch2 = [];
    this.sampleBatch3 = [];
    this.sampleBatch4 = [];
    this.sampleBatch1PosControlsPositions = [];
    this.sampleBatch2PosControlsPositions = [];
    this.sampleBatch3PosControlsPositions = [];
    this.sampleBatch4PosControlsPositions = [];
    this.sampleBatch1PosControlsPositionsturned = [];
    this.sampleBatch2PosControlsPositionsturned = [];
    this.sampleBatch3PosControlsPositionsturned = [];
    this.sampleBatch4PosControlsPositionsturned = [];
    this.plateMap = this.createMapOutOfCovidSamplesDifferentMap(this.plateViewData, this.plateMap, 0, 0, 1);
    this.counter = 0;
    if (this.selectedBatch.wellType === WellType.WELL384) {
      for (let i = 0; i < this.selectedBatch.samples.length; i++) {
        if (this.selectedBatch.samples[i].positionRow % 2 != 0 && this.selectedBatch.samples[i].prositionCol % 2 != 0) {
          this.sampleBatch1.push(this.selectedBatch.samples[i]);
          if (this.selectedBatch.samples[i].barcode == APGCovid19Constants.positiveControlBarcode) {
            this.sampleBatch1PosControlsPositions.push(this.getPosition(this.selectedBatch.samples[i], 1, 1, 2));
            this.sampleBatch1PosControlsPositionsturned.push(this.getPositionturned(this.selectedBatch.samples[i], 1, 1, 2))
          }
          if (this.plateOne == undefined) {
            this.plateOne = this.selectedBatch.sourceBatchIds[this.counter++];
          }
        } else
          if (this.selectedBatch.samples[i].positionRow % 2 == 0 && this.selectedBatch.samples[i].prositionCol % 2 != 0) {
            this.sampleBatch2.push(this.selectedBatch.samples[i]);
            if (this.selectedBatch.samples[i].barcode == APGCovid19Constants.positiveControlBarcode) {
              this.sampleBatch2PosControlsPositions.push(this.getPosition(this.selectedBatch.samples[i], 0, 1, 2));
              this.sampleBatch2PosControlsPositionsturned.push(this.getPositionturned(this.selectedBatch.samples[i], 0, 1, 2));
            }
            if (this.plateTwo == undefined) {
              this.plateTwo = this.selectedBatch.sourceBatchIds[this.counter++];
            }
          } else
            if (this.selectedBatch.samples[i].positionRow % 2 != 0 && this.selectedBatch.samples[i].prositionCol % 2 == 0) {
              this.sampleBatch3.push(this.selectedBatch.samples[i]);
              if (this.selectedBatch.samples[i].barcode == APGCovid19Constants.positiveControlBarcode) {
                this.sampleBatch3PosControlsPositions.push(this.getPosition(this.selectedBatch.samples[i], 1, 0, 2));
                this.sampleBatch3PosControlsPositionsturned.push(this.getPositionturned(this.selectedBatch.samples[i], 1, 0, 2));
              }
              if (this.plateThree == undefined) {
                this.plateThree = this.selectedBatch.sourceBatchIds[this.counter++];
              }
            } else
              if (this.selectedBatch.samples[i].positionRow % 2 == 0 && this.selectedBatch.samples[i].prositionCol % 2 == 0) {
                this.sampleBatch4.push(this.selectedBatch.samples[i]);
                if (this.selectedBatch.samples[i].barcode == APGCovid19Constants.positiveControlBarcode) {
                  this.sampleBatch4PosControlsPositions.push(this.getPosition(this.selectedBatch.samples[i], 0, 0, 2));
                  this.sampleBatch4PosControlsPositionsturned.push(this.getPositionturned(this.selectedBatch.samples[i], 0, 0, 2));
                }
                if (this.plateFour == undefined) {
                  this.plateFour = this.selectedBatch.sourceBatchIds[this.counter++];
                }
              }
      }
      this.getSubSendersForPlateOne();
      this.getSubSendersForPlateTwo();
      this.getSubSendersForPlateThree();
      this.getSubSendersForPlateFour();
      this.sampleBatch1Map = this.createMapOutOfCovidSamplesDifferentMap(this.sampleBatch1, this.sampleBatch1Map, 1, 1, 2);
      this.sampleBatch2Map = this.createMapOutOfCovidSamplesDifferentMap(this.sampleBatch2, this.sampleBatch2Map, 0, 1, 2);
      this.sampleBatch3Map = this.createMapOutOfCovidSamplesDifferentMap(this.sampleBatch3, this.sampleBatch3Map, 1, 0, 2);
      this.sampleBatch4Map = this.createMapOutOfCovidSamplesDifferentMap(this.sampleBatch4, this.sampleBatch4Map, 0, 0, 2);
    }
  }


  createMapOutOfCovidSamplesDifferentMap(plateData: CovidSamples[], mapOfPlate: Map<string, CovidSamples>, rowAdder: number, colAdder: number, divider: number) {
    mapOfPlate = new Map();
    this.mutationRecentDate=new Date(0);
    if (plateData) {
      plateData.forEach(sample => {
        if (sample) {
          this.getMutationRecentDate(sample);
          let posRow = sample.positionRow96 && sample.positionRow96 != 0 ? sample.positionRow96 : sample.positionRow;
          let posCol = sample.positionRow96 && sample.positionCol96 != 0 ? sample.positionCol96 : sample.prositionCol;
          mapOfPlate.set(this.getRowColStringFromPos(posRow - 1, posCol - 1), sample);
        }
      });
    }
    return mapOfPlate;
  }


  /**
   * Get the positional String from row and col number.
   * Ex: (1, 1) returns 'A1'
   * @param row
   * @param col
   */
  getRowColStringFromPos(row: number, col: number) {
    return this.rowHeaders384[row] + this.columnHeaders384[col];
  }

  /**
   * Get samples at given row col value for the plate view
   * @param row
   * @param col
   */
  getSampleAt(row: number, col: number, mapOfBatch: Map<string, CovidSamples>) {

    let positionString = this.getRowColStringFromPos(row, col);
    if (mapOfBatch.has(positionString)) {
      return mapOfBatch.get(positionString);
    }
    let sample = new CovidSamples();
    sample.barcode = '';
    return sample;
  }

  getColor(row: number, col: number, mapOfBatch: Map<string, CovidSamples>) {
    let positionString = this.getRowColStringFromPos(row, col);

    if (this.val2 === '384') {

      if ((row + 1) % 2 != 0 && (col + 1) % 2 != 0 && mapOfBatch.has(positionString)) {
        this.backGroundColor = "#5858fa";
      } else if ((row + 1) % 2 == 0 && (col + 1) % 2 != 0 && mapOfBatch.has(positionString)) {
        this.backGroundColor = "#ff9000";
      } else if ((row + 1) % 2 != 0 && (col + 1) % 2 == 0 && mapOfBatch.has(positionString)) {
        this.backGroundColor = "#39ff14";
      } else if ((row + 1) % 2 == 0 && (col + 1) % 2 == 0 && mapOfBatch.has(positionString)) {
        this.backGroundColor = "#886a08";
      }

    }
    if (mapOfBatch.has(positionString)) {

      this.setColorsForSamplesAndControls(mapOfBatch.get(positionString));

    } else {
      this.color = "white";
      this.backGroundColor = "#FFFFFF";
      this.circleBorder = "black";
      this.circleStroke = "3";
      this.crossWidth = "0";
      this.crossColor = "white";
    }

  }

  setColorsForSamplesAndControls(sample: CovidSamples) {
    if ( sample.barcode.includes("PC")) {
      this.color = "aqua";
    }else if (sample.barcode.includes("NTC")) {
      this.color = "yellow";
    } else {
      this.color = "violet";
    }
    this.circleStroke = "3";
    this.circleBorder = "black";
    this.crossWidth = "0";
    this.crossColor = "white";

  }

  setControlOkColors() {
    this.circleBorder = "green";
    this.circleStroke = "5";
    this.crossWidth = "0";
    this.crossColor = "white";
  }

  setControlFailedColors() {
    this.circleBorder = "black";
    this.circleStroke = "3";
    this.crossWidth = "4";
    this.crossColor = "red";
  }

  noChannelsFound(pcrKit: any) {
    return ((!pcrKit.channel1Gene || pcrKit.channel1Gene.trim() == '') && (!pcrKit.channel2Gene || pcrKit.channel2Gene.trim() == '') &&
      (!pcrKit.channel3Gene || pcrKit.channel3Gene.trim() == '') && (!pcrKit.channel4Gene || pcrKit.channel4Gene.trim() == '') && (!pcrKit.channel5Gene || pcrKit.channel5Gene.trim() == ''));
  }
  channelsCount(pcrKit: any) {
    let count = 0;
    if (pcrKit) {
      if (pcrKit.channel1Gene && pcrKit.channel1Gene.trim() != '') {
        count++;
      }
      if (pcrKit.channel2Gene && pcrKit.channel2Gene.trim() != '') {
        count++;
      }
      if (pcrKit.channel3Gene && pcrKit.channel3Gene.trim() != '') {
        count++;
      }
      if (pcrKit.channel4Gene && pcrKit.channel4Gene.trim() != '') {
        count++;
      }
      if (pcrKit.channel5Gene && pcrKit.channel5Gene.trim() != '') {
        count++;
      }
    }
    return count;
  }
  onResultFileChange(event) {

    if (event.target.files.length > 2) {
      this._messagesService.addWarningMessage({
        severity: 'error', summary: 'Uploaded more than 2 files!',
        detail: 'Maximum of 2 files can be uploaded!',
      });
      this.removeSelection();
      return;
    }
    this.fileTypeCountMap.clear();
    for (var i = 0; i < event.target.files.length; i++) {
      var file = event.target.files[i];
      if (this.manufacturerConfigMap && this.manufacturerConfigMap.size > 0) {
        let filePatterns = this.manufacturerConfigMap.get(file.name.split('.').pop());
        if (!filePatterns || filePatterns == null) {
          this._messagesService.addWarningMessage({
            severity: 'error', summary: 'Please upload a file with valid extension',
            detail: 'allowed file extensions are ' + Array.from(this.manufacturerConfigMap.keys()).join(",")
          });
          this.removeSelection();
          return;
        }
        if (this.fileTypeCountMap.has(file.name.split('.').pop())) {
          this._messagesService.addErrorMessage({
            severity: 'error', summary: 'More than 1 File Selected',
            detail: 'Max 1 file can be uploaded of a specific type at  a time!'
          });
          this.removeSelection();
          return;
        }
        let patternApplied = false;
        filePatterns.forEach(filePattern => {
          let pattern = filePattern.pattern.replace("<batchID>", this.selectedBatch.batchID);
          if (file.name.includes(pattern)) {

            this.myFiles.push(event.target.files[i]);
            this.fileTypeCountMap.set(file.name.split('.').pop(), 1);
            if (file.type == 'text/plain') {
              if (APGCovid19Constants.splitCondition == this.machineIOCapcity.get(this.selectedBatch.machineName1)) {
                let array = file.name.split("_");
                let quad = array[array.length - 1].split(".")[0];
                if (quad === "A2") {
                  quad = "B1";
                }
                else if (quad === "B1") {
                  quad = "A2";
                }
                let batchId = this.selectedBatch.batchID.split('_');
                if (!file.name.includes(batchId[batchId.length - 1]) || quad != this.selectedBatch.quadrant) {
                  this._messagesService.addWarningMessage({
                    severity: 'error', summary: 'File mismatch',
                    detail: 'Please upload correct file with proper quadrant',
                  });
                  this.removeSelection();
                  return;
                }
              }
              this.gene = this.getGeneFromFileName(file.name, this.selectedBatch.rtPCRKitVendor);
              if (this.gene == 'error' && APGCovid19Constants.splitCondition != this.machineIOCapcity.get(this.selectedBatch.machineName1)) {
                this.gene = this.emptyGeneName;
                this._messagesService.addErrorMessage({
                  severity: 'error', summary: 'Text file not recognized!',
                  detail: 'Uploaded filename does not match the gene channel result format in the kit.',
                });
                this.removeSelection();
                return;
              }
            }
            patternApplied = true;
            return;
          }
        });

        if (!patternApplied) {
          this._messagesService.addErrorMessage({
            severity: 'error', summary: 'Invalid File',
            detail: 'Uploaded File Pattern Does Not Match With Configured Patterns For Manufacturer...Please Contact Your Lab Manager to Configure the File Pattern in MDM!!'
          });
          this.removeSelection();
          return;
        }
      } else {
        if (this.machineShortInfos.get(this.selectedBatch.machineName1) == APGCovid19Constants.bioradLimsMechine) {
          this.validateBioradLimsFileUpload(event.target.files[i]);
        } else if (this.mapOfMachineInfo.get(this.selectedBatch.machineName1).fileType == APGCovid19Constants.fastFinder) {
          this.validateFastFinderFileUpload(event.target.files[i].name);
        } else if (this.filetypes.indexOf(event.target.files[i].name.split('.').pop()) == -1) {
          this._messagesService.addWarningMessage({
            severity: 'error', summary: 'Please upload a file with valid extension',
            detail: 'allowed file extensions are .ixo, .xml and .txt',
          });
          this.removeSelection();
          return;
        }
        this.myFiles.push(event.target.files[i]);
        if (file.type == 'text/plain') {
          if (APGCovid19Constants.splitCondition == this.machineIOCapcity.get(this.selectedBatch.machineName1)) {
            let array = file.name.split("_");
            let quad = array[array.length - 1].split(".")[0];
            if (quad === "A2") {
              quad = "B1";
            }
            else if (quad === "B1") {
              quad = "A2";
            }
            let batchId = this.selectedBatch.batchID.split('_');
            if (!file.name.includes(batchId[batchId.length - 1]) || quad != this.selectedBatch.quadrant) {
              this._messagesService.addWarningMessage({
                severity: 'error', summary: 'File mismatch',
                detail: 'Please upload correct file with proper quadrant',
              });
              this.removeSelection();
              return;
            }
          }
          this.gene = this.getGeneFromFileName(file.name, this.selectedBatch.rtPCRKitVendor);
          if (this.gene == 'error' && APGCovid19Constants.splitCondition != this.machineIOCapcity.get(this.selectedBatch.machineName1)) {
            this.gene = this.emptyGeneName;
            this._messagesService.addErrorMessage({
              severity: 'error', summary: 'Text file not recognized!',
              detail: 'Uploaded filename does not match the gene channel result format in the kit.',
            });
            this.removeSelection();
            return;
          } else {
            this.uploadedTxtFiles.push(file.type);
          }
        } else if (file.name.endsWith(".ixo")) {
          this.ixoFiles.push(file);
        } else if (file.name.endsWith(".xml")) {
          if (this.machineShortInfos.get(this.selectedBatch.machineName1) != APGCovid19Constants.LC480SubType) {
            this._messagesService.addErrorMessage({
              severity: 'error', summary: 'XML file not Alloed!',
              detail: 'XML file is not allowed for selected Cycler.',
            });
            this.removeSelection();
          }
          if (this.uploadedXMLFiles.length < 1) {
            this.uploadedXMLFiles.push(file);
          } else {
            this._messagesService.addWarningMessage({
              severity: 'error', summary: 'Uploaded more than 1 XML file!',
              detail: 'Maximum of 1 XML file can be uploaded!',
            });
            this.removeSelection();
          }
        }
      }
      if (this.uploadedTxtFiles.length > 1) {
        this._messagesService.addWarningMessage({
          severity: 'error', summary: 'Uploaded more than 1 .txt file!',
          detail: 'Maximum of 1 .txt file can be uploaded!',
        });
        this.removeSelection();
        this.uploadedTxtFiles = [];
      }
      if (this.ixoFiles.length > 1) {
        this._messagesService.addWarningMessage({
          severity: 'error', summary: 'Uploaded more than 1 .ixo file!',
          detail: 'Maximum of 1 .ixo file can be uploaded!',
        });
        this.removeSelection();
      } else if (this.ixoFiles.length > 0 && this.uploadedPCRDFiles.length > 0) {
        this._messagesService.addWarningMessage({
          severity: 'error', summary: 'Both pcrd and ixo files not allowed',
          detail: 'either pcrd or ixo file is allowed to upload',
        });
        this.removeSelection();
      }
    }
    this.disableResultUpload();
  }



  validateFastFinderFileUpload(fileName: string) {
    let batchId = this.selectedBatch.batchID.split('_');
    if (!fileName.includes(batchId[batchId.length - 1]) || this.fastFinderFiletypes.indexOf(fileName.split('.').pop()) == -1) {
      this._messagesService.addErrorMessage({
        severity: 'error', summary: 'File Mismatch',
        detail: 'Upload valid  File with BatchId & extension .xlsx,.ixo,.csv or .pcrd',
      });
      this.removeSelection();
      return
    }
  }
  validateBioradLimsFileUpload(file) {
    if (this.bioradLimsFiletypes.indexOf(file.name.split('.').pop()) == -1) {
      this._messagesService.addWarningMessage({
        severity: 'error', summary: 'Please upload a file with valid extension',
        detail: 'allowed file extensions are  .xlsx,.ixo,.csv and .pcrd',
      });
      this.removeSelection();
      return;
    } else if (file.name.endsWith('.xlsx')) {
      if (this.uploadedxlsxFiles.length < 1) {
        this.uploadedxlsxFiles.push(file);
      } else {
        this._messagesService.addWarningMessage({
          severity: 'error', summary: 'Uploaded more than 1 excel file!',
          detail: 'Maximum of 1 excel file can be uploaded!',
        });
        this.removeSelection();
      }
    } else if (file.name.endsWith('.pcrd')) {
      if (this.uploadedPCRDFiles.length < 1) {
        this.uploadedPCRDFiles.push(file);
      } else {
        this._messagesService.addWarningMessage({
          severity: 'error', summary: 'Uploaded more than 1 pcrd  file!',
          detail: 'Maximum of 1 pcrd file can be uploaded!',
        });
        this.removeSelection();
      }
    } else if (file.name.endsWith('.csv')) {
      if (this.uploadedCSVFiles.length < 1) {
        this.uploadedCSVFiles.push(file);
      } else {
        this._messagesService.addWarningMessage({
          severity: 'error', summary: 'Uploaded more than 1 CSV files!',
          detail: 'Maximum of 1 CSV file can be uploaded!',
        });
        this.removeSelection();
      }
    }
  }
  disableResultUpload() {
    if (this.myFiles.length > 0) {
      this.isResultUploadDisabled = false;
    } else {
      this.isResultUploadDisabled = true;
    }
  }

  removeSelection() {
    (<HTMLInputElement>document.getElementById("resultFileChooser")).value = null;
    this.myFiles = [];
    this.uploadedTxtFiles = [];
    this.ixoFiles = [];
    this.uploadedxlsxFiles = [];
    this.uploadedPCRDFiles = [];
    this.uploadedXMLFiles = [];
    this.uploadedCSVFiles = [];
    this.fileTypeCountMap = new Map();
    this.disableResultUpload();
  }

  resultUploadsubmit() {
    const formData = new FormData();
    for (var i = 0; i < this.myFiles.length; i++) {
      formData.append("file", this.myFiles[i]);
    }
    if (this.isPUIDPresnt()) {
      this.removeSelection();
      if (this.gene == 'ICR' && !this.allNonICRChannelsUploaded() && this.machineShortInfos.get(this.selectedBatch.machineName1) != APGCovid19Constants.bioradLimsMechine) {
        this._messagesService.addErrorMessage({ severity: 'error', summary: 'ICR Channel Upload Error', detail: 'Please upload all non-ICR channel result files before uploading ICR channel' });
        return;
      }
      formData.append("resultConfigMap", JSON.stringify(this.resultGroupMap));
      let dominantChannel = this.getDominantChannelFromKit(this.selectedBatch.rtPCRKitVendor);
      let filesPerManufacturer = (this.manufacturerConfigMap && this.manufacturerConfigMap.size > 0) ? true : false;
      formData.append("filesPerManufacturer", filesPerManufacturer.toString());
      this.blocked = true;
      this.apgTestingService.uploadResultFile(formData, this.selectedBatch.batchID, this.gene, dominantChannel, this.selectedLabId, this.selectedBatch.rtPCRKitVendor, this.machineIOCapcity.get(this.selectedBatch.machineName1), this.mapOfMachineInfo.get(this.selectedBatch.machineName1).fileType).subscribe(
        result => {
          if (!result.data) {
            this.blocked = false;
            this._messagesService.addSuccessMessage({ severity: 'success', summary: 'Result Uploaded', detail: 'Upload Successful' });
            return;
          }
          this.selectedBatch = result.data;
          this.updatePlateMaps();
          if (this.allChannelsUpdatedForBatch() && !(this.selectedBatch.completionDateTimeEvaluation && this.selectedBatch.puidEvaluation)) {
            if (this.selectedBatch.wellType == WellType.WELL96) {
              if (this.selectedBatch.systemResult) {
                this.selectedBatch.finalResult = "Report";
              }
              else {
                this.selectedBatch.finalResult = "Check";
              }
            }
            else {
              this.userWarningsForAdjacentPositiveSamples();
              this.selectedBatch.mergedBatches.forEach(meregedBatch => {
                if (meregedBatch.systemResult) {
                  meregedBatch.finalResult = "Report";
                }
                else {
                  meregedBatch.finalResult = "Check";
                }
              })
            }
          }
          this.verifyAllSampleChecksResolved(this.plateMap, true);
          if (this.missingBarcodesList && this.missingBarcodesList.length > 0) {
            let message = 'Theese barcodes are missing from file ' + this.missingBarcodesList.join(',  ') + " . Please Reupload file with missing barcodes to Proceed";
            this._messagesService.addErrorMessage({
              severity: 'error', summary: 'Barcodes Missing in Upload File',
              detail: message,
            })
            this.blocked = false;
            return;
          }
          this.filesPerManufacturerMap.clear();
          if (this.manufacturerConfigMap && this.manufacturerConfigMap.size > 0 && this.selectedBatch.filesPerManufacturer && this.selectedBatch.filesPerManufacturer.length > 0) {
            this.selectedBatch.filesPerManufacturer.forEach(file => {
              let newFile: FilesPerManufacturer[] = [];
              if (this.filesPerManufacturerMap.has(file.fileType)) {
                let uploadedFilesForFileType = this.filesPerManufacturerMap.get(file.fileType);
                uploadedFilesForFileType.push(file);
                this.filesPerManufacturerMap.set(file.fileType, uploadedFilesForFileType);
              } else {
                newFile.push(file);
                this.filesPerManufacturerMap.set(file.fileType, newFile);
              }
            });
          }

          this._messagesService.addSuccessMessage({ severity: 'success', summary: 'Result Uploaded', detail: 'Upload Successful' });
          this.blocked = false;
        },
        error => {
          let message = this.errorHandler.handleError(error);
          this._messagesService.addErrorMessage(message);
          this.blocked = false;
        }
      )
    } else {
      this._messagesService.addWarningMessage({
        severity: 'warn', summary: 'USER ID not present!',
        detail: 'Please  enter USER ID before uploading',
      });
    }
  }
  userWarningsForAdjacentPositiveSamples() {
    if (this.sampleBatch1PosControlsPositions.length > 0) {
      this.warnUsersAboutAdjacentPositiveSamples(this.sampleBatch1PosControlsPositions, this.plateOne, this.sampleBatch2Map, this.plateTwo, this.sampleBatch3Map, this.plateThree, this.sampleBatch4Map, this.plateFour, false);
      this.warnUsersAboutAdjacentPositiveSamples(this.sampleBatch1PosControlsPositionsturned, this.plateOne, this.sampleBatch2Map, this.plateTwo, this.sampleBatch3Map, this.plateThree, this.sampleBatch4Map, this.plateFour, true);
    }
    if (this.sampleBatch2PosControlsPositions.length > 0) {
      this.warnUsersAboutAdjacentPositiveSamples(this.sampleBatch2PosControlsPositions, this.plateTwo, this.sampleBatch1Map, this.plateOne, this.sampleBatch3Map, this.plateThree, this.sampleBatch4Map, this.plateFour, false);
      this.warnUsersAboutAdjacentPositiveSamples(this.sampleBatch2PosControlsPositionsturned, this.plateTwo, this.sampleBatch1Map, this.plateOne, this.sampleBatch3Map, this.plateThree, this.sampleBatch4Map, this.plateFour, true);
    }
    if (this.sampleBatch3PosControlsPositions.length > 0) {
      this.warnUsersAboutAdjacentPositiveSamples(this.sampleBatch3PosControlsPositions, this.plateThree, this.sampleBatch2Map, this.plateTwo, this.sampleBatch1Map, this.plateOne, this.sampleBatch4Map, this.plateFour, false);
      this.warnUsersAboutAdjacentPositiveSamples(this.sampleBatch3PosControlsPositionsturned, this.plateThree, this.sampleBatch2Map, this.plateTwo, this.sampleBatch1Map, this.plateOne, this.sampleBatch4Map, this.plateFour, true);
    }
    if (this.sampleBatch4PosControlsPositions.length > 0) {
      this.warnUsersAboutAdjacentPositiveSamples(this.sampleBatch4PosControlsPositions, this.plateFour, this.sampleBatch2Map, this.plateTwo, this.sampleBatch3Map, this.plateThree, this.sampleBatch1Map, this.plateOne, false);
      this.warnUsersAboutAdjacentPositiveSamples(this.sampleBatch4PosControlsPositionsturned, this.plateFour, this.sampleBatch2Map, this.plateTwo, this.sampleBatch3Map, this.plateThree, this.sampleBatch1Map, this.plateOne, true);
    }
  }

  warnUsersAboutAdjacentPositiveSamples(posExPositions, batchId, verifyMap1, verifyBatchId1, verifyMap2, verifyBatchId2, verifyMap3, verifyBatchId3, turned) {
    let firstBatch: boolean = true;
    let secondBatch: boolean = true;
    let thirdBatch: boolean = true;
    let message: string = "";
    posExPositions.forEach(element => {
      let firstsample: CovidSamples = verifyMap1.get(element);
      if (firstsample == undefined || firstsample.result != APGCovid19Constants.samplePositiveResult || this.controlArray.includes(firstsample.barcode))
        firstBatch = false;
      let secondsample: CovidSamples = verifyMap2.get(element);
      if (secondsample == undefined || secondsample.result != APGCovid19Constants.samplePositiveResult || this.controlArray.includes(secondsample.barcode))
        secondBatch = false;
      let thirdSample: CovidSamples = verifyMap3.get(element);
      if (thirdSample == undefined || thirdSample.result != APGCovid19Constants.samplePositiveResult || this.controlArray.includes(thirdSample.barcode))
        thirdBatch = false;
    });
    if (firstBatch) {
      message = message.concat(batchId + " POS-EX positive on " + verifyBatchId1 + (turned ? "(turned)" : ""));
    }
    if (secondBatch) {
      message = message != "" ? message.concat("<br/>") : "";
      message = message.concat(batchId + " POS-EX positive on " + verifyBatchId2 + (turned ? "(turned)" : ""));
    }
    if (thirdBatch) {
      message = message != "" ? message.concat("<br/>") : "";
      message = message.concat(batchId + " POS-EX positive on " + verifyBatchId3 + (turned ? "(turned)" : ""));
    }
    if (message != "") {
      this._messagesService.addWarningMessage({
        severity: 'warn', summary: 'Adjacent Positive samples',
        detail: message,
      });
    }
  }

  showSamplePopUp(row: number, col: number, mapOfBatch: Map<string, CovidSamples>) {
    let positionString = this.getRowColStringFromPos(row, col);
    this.dominantChannelName = this.getDominantChannelFromKit(this.selectedBatch.rtPCRKitVendor);
    if (mapOfBatch.has(positionString)) {
      this.samplePosition = positionString;
      this.selectedSample = Object.assign({}, mapOfBatch.get(positionString));
      if (this.selectedSample.channels) {
        this.selectedSample.channels.sort((channel1: Channel, channel2: Channel) => {
          return channel1.gene.localeCompare(channel2.gene);
        });
      }
      this.tempSampleComment = this.selectedSample.comments;
      this.tempSampleInvalid = this.selectedSample.inValidResult;
      this.tempSampleResult = this.selectedSample.result;
      this.isResultGroup = false;
      if (Object.keys(this.resultGroupMap).length > 0 && this.selectedSample.results.length > 0 && this.controlArray.indexOf(this.selectedSample.barcode) == -1) {
        this.isResultGroup = true;
      }
      this.sampleType = (this.controlArray.includes(this.selectedSample.barcode)) ? this.selectedSample.barcode : 'Sample';
      this.batchHeaders = [];
      this.batchHeaders.push("Current");
      this.selectedSampleHistoryMap = this.getSelectedSampleHistoryMap(this.selectedSample.barcode);
      this.headerIndex = 0;
      this.reset[0] = {};
      this.samplePopVisible = true;
    }
  }

  getChannelsdata(resultName: string) {
    let channels: any[] = [];
    if (Object.keys(this.resultGroupMap).length > 0) {
      let data = this.resultGroupMap[resultName];
      if (data != undefined) {
        data['channelThreshold'].forEach(channel => {
          channels.push(channel['channelName']);
        });
      }
    }
    return channels;
  }
  updateOverviewPlate(sample: CovidSamples) {
    switch (sample.quadrant) {
      case 'A1': this.sampleBatch1Map.set(this.getPosition(sample, 1, 1, 2), sample);
        break;
      case 'A2': this.sampleBatch2Map.set(this.getPosition(sample, 0, 1, 2), sample);
        break;
      case 'B1': this.sampleBatch3Map.set(this.getPosition(sample, 1, 0, 2), sample);
        break;
      case 'B2': this.sampleBatch4Map.set(this.getPosition(sample, 0, 0, 2), sample);
        break;
    }
  }
  getPosition(sample: CovidSamples, rowAdder: number, colAdder: number, divider: number) {
    let posRow = (sample.positionRow + rowAdder) / divider;
    let posCol = (sample.prositionCol + colAdder) / divider;
    return this.getRowColStringFromPos(posRow - 1, posCol - 1);
  }
  getPositionturned(sample: CovidSamples, rowAdder: number, colAdder: number, divider: number) {
    let posRow = 9 - ((sample.positionRow + rowAdder) / divider);
    let posCol = 13 - ((sample.prositionCol + colAdder) / divider);
    return this.getRowColStringFromPos(posRow - 1, posCol - 1);
  }

  saveSampleDataDuringAnalysis() {
    if (this.selectedSample.results != undefined && this.selectedSample.results.length > 0 && Object.keys(this.resultGroupMap).length > 0 && !this.controlArray.includes(this.selectedSample.barcode)) {
      let result = this.selectedSample.results.find(x => x.testingType.includes('Covid'));
      this.selectedSample.result = result != undefined ? result.sampleResult : this.selectedSample.result;
    }
    this.selectedSample.inValidResult = (this.selectedSample.result == 'invalid');
    this.apgTestingService.updateSamples(this.selectedBatch.batchID, this.selectedSample, this.selectedLabId, this.selectedBatch.wellType, this.selectedBatch.sender, this.selectedBatch.rushSample).subscribe(
      result => {
        if (result.data) {
          this.samplePopVisible = false;
          this.selectedBatch.version = this.selectedBatch.version + 1;
          this.plateMap.set(this.getRowColStringFromPos(this.selectedSample.positionRow - 1, this.selectedSample.prositionCol - 1), this.selectedSample);
          this.verifyAllSampleChecksResolved(this.plateMap, false);
          this.updateOverviewPlate(this.selectedSample);
          this._messagesService.addSuccessMessage({ severity: 'success', summary: 'Sample Updated', detail: result.data });
        }
      },
      error => {
        this.resetSample();
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      }
    );
  }

  resetSample() {
    this.selectedSample.result = this.tempSampleResult;
    this.selectedSample.inValidResult = this.tempSampleInvalid;
    this.selectedSample.comments = this.tempSampleComment;
    this.plateMap.set(this.getRowColStringFromPos(this.selectedSample.positionRow - 1, this.selectedSample.prositionCol - 1), this.selectedSample);
  }

  disablePopUpUse() {
    return (!['ANALYSIS_STARTED', 'ANALYSIS_DONE'].includes(this.selectedBatch.statusOfTheBatch));
  }

  updatePlateMaps() {
    let sampleData = this.selectedBatch.samples;
    this.createPlateMaps(sampleData);
  }

  confirmCompleteAnalysis() {
    if (this.selectedBatch.locked) {
      this.confirmationService.confirm({
        message: 'This batch is locked for sending out data. Do you still want to complete analysis?',
        acceptLabel: 'OK',
        header: 'Warning',
        icon: 'pi pi-exclamation-triangle',
        key: 'warning',
        accept: () => {
          this.confirmPlates();
        },
        reject: () => { }
      })
    } else {
      this.confirmPlates();
    }
  }

  confirmPlates() {
    if (!this.isPUIDPresnt()) {
      this._messagesService.addWarningMessage({
        severity: 'warn', summary: 'USER ID not present!',
        detail: 'Please  enter USER ID before uploading',
      });
      this.blocked = false;
      return;
    }

    if (!this.allResultsSelected()) {
      this._messagesService.addErrorMessage({
        severity: 'error', summary: 'Result Not Selected!',
        detail: 'Please Select a Result other than Check For Each Batch From Result DropDown',
      });
      this.blocked = false;
      return;
    }

    if (this.manufacturerConfigMap && this.manufacturerConfigMap.size > 0) {
      let missingPatterns = this.checkIfAllMandatoryFilesUploaded();
      if (missingPatterns && missingPatterns.length > 0) {
        this.confirmationService.confirm({
          message: 'Not All Mandatory Files are Uploaded, Do you still want to proceed?',
          acceptLabel: 'OK',
          header: 'Warning',
          icon: 'pi pi-exclamation-triangle',
          key: 'warning',
          accept: () => {
            this.showRedoDialog();
          },
          reject: () => { }
        })
      } else {
        this.showRedoDialog();
      }
    } else {
      this.showRedoDialog();
    }
  }

  showRedoDialog() {
    if ((this.selectedBatch.finalResult && this.selectedBatch.finalResult !== 'Report') ||
      (this.selectedBatch.mergedBatches &&
        this.selectedBatch.mergedBatches[0] && this.selectedBatch.mergedBatches[0].finalResult !== 'Report'
        && !this.selectedBatch.mergedBatches[0].redone) ||
      (this.selectedBatch.mergedBatches &&
        this.selectedBatch.mergedBatches[1] && this.selectedBatch.mergedBatches[1].finalResult !== 'Report'
        && !this.selectedBatch.mergedBatches[1].redone) ||
      (this.selectedBatch.mergedBatches &&
        this.selectedBatch.mergedBatches[2] && this.selectedBatch.mergedBatches[2].finalResult !== 'Report'
        && !this.selectedBatch.mergedBatches[2].redone) ||
      (this.selectedBatch.mergedBatches &&
        this.selectedBatch.mergedBatches[3] && this.selectedBatch.mergedBatches[3].finalResult !== 'Report'
        && !this.selectedBatch.mergedBatches[3].redone)) {

      this.confirmationService.confirm({
        message: this.redoDialogMessage,
        header: 'Redo?',
        accept: () => {
          if (this.reportingOutsideBB) {
            this.completeAnalysisForReportingOutsideProcess();
          } else {
            this.showAnalysisVerificationDialog();
          }
        },
        reject: () => { }
      });
    } else {
      if (this.reportingOutsideBB) {
        this.completeAnalysisForReportingOutsideProcess();
      } else {
        this.showAnalysisVerificationDialog();
      }
    }
  }
  showAnalysisVerificationDialog() {
    this.columnList = [];
    this.changedSampleList = [];
    let isresultGroupPresent = false;
    this.plateMap.forEach((value, key) => {
      let sample: CovidSamples = Object.assign({}, this.plateMap.get(key));
      if (Object.keys(this.resultGroupMap).length > 0 && this.controlArray.indexOf(sample.barcode) == -1 && (sample.results != undefined && sample.results.length > 0)) {
        sample.results.forEach(element => {
          if (element.sampleResult != element.originalSampleResult) {
            sample.result = element.sampleResult;
            sample.originalResult = element.originalSampleResult;
            sample.contaminationType = element.testingType;
            this.changedSampleList.push(Object.assign({}, sample));
            isresultGroupPresent = true;
          }
        });
      } else if (value && !['POS_EX', 'NTC_EX', 'PCR-PC', 'PCR-NTC'].includes(value.barcode)) {
        if (value.originalResult && value.originalResult !== value.result) {
          this.changedSampleList.push(value);
        }
      }
    });
    if (isresultGroupPresent) {
      this.columnList.push({ field: 'resultGroup', header: 'ResultGroup', colspan: 1 });
    }
    this.columnList.push({ field: 'position', header: 'Position', colspan: 1 });
    this.columnList.push({ field: 'barcode', header: 'Barcode', colspan: 1 });
    this.selectedBatch.samples[0].channels.forEach(channel => {
      this.columnList.push({ field: '', header: channel.gene, colspan: 1 });
    });
    this.columnList.push({ field: 'originalResult', header: 'Original Result', colspan: 1 });
    this.columnList.push({ field: 'result', header: 'Edited Result', colspan: 1 });
    this.columnList.push({ field: 'comment', header: 'Comment', colspan: 3 },);
    this.showAnalysisDialog = true;
    setTimeout(() => {
      document.getElementById('analysisVerificationField').focus();
    }, 50);
  }

  completeAnalysisProcess() {
    this.showAnalysisDialog = false;
    if ((this.analysisVerifyPUID.toLowerCase() === this.puid.toLowerCase())) {
      this._messagesService.addErrorMessage({
        severity: 'error', summary: 'Verification Failed!',
        detail: 'User ID must not be same as logged in PUID',
      });
      return;
    }
    this.blocked = true;
    let resultMap: Map<string, CovidSamples>;
    let isRedoReasonSelected = true;
    if (this.selectedBatch.wellType == WellType.WELL384) {
      this.selectedBatch.mergedBatches.forEach(mergedBatch => {
        if (mergedBatch.finalResult != 'Report' && !mergedBatch.redoReason)
          isRedoReasonSelected = false;
      });
      resultMap = this.getResultMapFor384();
    } else {
      isRedoReasonSelected = !(this.selectedBatch.finalResult != 'Report' && !this.selectedBatch.redoReason);
      resultMap = this.getResultMapFor96();
    }
    if (!isRedoReasonSelected) {
      this._messagesService.addErrorMessage({
        severity: 'error', summary: 'Redo Reason Not Selected!',
        detail: 'Please Select Redo Reason for Each Batch Set for Redo',
      });
      this.blocked = false;
      return;
    }
    this.selectedBatch.samplesMap = [];
    let resultObject = {};
    resultMap.forEach((v: CovidSamples, k: string) => {
      if (v) {
        resultObject[k] = v;
      }
    });
    this.selectedBatch.analysisVerificationPUID = this.analysisVerifyPUID;
    this.selectedBatch.username = this.analysisVerifyPUID;
    this.selectedBatch.password = this.convertStringToUTF8ByteArray(this.enteredPassword);
    this.selectedBatch.eventForAuthorization = true;
    this.analysisVerifyPUID = null;
    this.enteredPassword = null;
    this.selectedBatch.samplesMap = resultObject;
    this.selectedBatch.completionDateTimeEvaluation = new Date();
    this.selectedBatch.statusOfTheBatch = 'ANALYSIS_DONE';
    this.selectedBatch.previousStatusOfTheBatch = 'ANALYSIS_DONE';
    this.selectedBatch.channelTestingTypeMapping = this.getChannelTestingMapper();
    this.apgTestingService.confirmPlates(this.selectedBatch, this.reportingOutsideBB).subscribe(
      result => {
        if (result.data) {
          this.selectedBatch = result.data;
          this._messagesService.addSuccessMessage({
            severity: 'success', summary: 'Result Upload Successful',
            detail: 'Proceed with file download to view result',
          });
        }
        this.blocked = false;
      },
      error => {
        this.selectedBatch.completionDateTimeEvaluation = null;
        this.selectedBatch.puidEvaluation = '';
        this.selectedBatch.statusOfTheBatch = 'ANALYSIS_STARTED';
        this.selectedBatch.previousStatusOfTheBatch = 'ANALYSIS_STARTED';
        this.selectedBatch.analysisVerificationPUID = null;
        this.selectedBatch.username = null;
        this.selectedBatch.password = null;
        this.selectedBatch.eventForAuthorization = false;
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
        this.blocked = false;
      }
    );

  }

  allResultsSelected() {
    if (this.selectedBatch.wellType === WellType.WELL96) {
      return (this.selectedBatch.finalResult && this.selectedBatch.finalResult != 'Check') ? true : false;
    }
    else {
      let allResultSelected = true;
      this.selectedBatch.mergedBatches.forEach(mergedBatch => {
        if (!mergedBatch.finalResult || mergedBatch.finalResult == 'Check')
          allResultSelected = false;
      })
      return allResultSelected;
    }
  }

  getResultMapFor384(): Map<string, CovidSamples> {
    let resultMap = new Map();
    let quadrantMap = this.getValidQuadrants();
    for (let i = 0; i < this.columnHeaders384.length; i++) {
      for (let j = 0; j < this.rowHeaders384.length; j++) {
        let rowPosString = this.getRowColStringFromPos(j, i);
        if (this.plateMap.has(rowPosString) && quadrantMap.has(this.quadrantFromRowColPos(rowPosString))) {
          resultMap.set(rowPosString, this.plateMap.get(rowPosString));
        } else {
          resultMap.set(rowPosString, null);
        }
      }
    }
    return resultMap;
  }

  getValidQuadrants(): Map<string, string> {
    let quadrantMap = new Map();
    for (let i = 0; i < this.selectedBatch.mergedBatches.length; i++) {
      if (this.selectedBatch.mergedBatches[i].finalResult == "Report") {
        quadrantMap.set(this.selectedBatch.mergedBatches[i].quadrant, "");
      }
    }
    return quadrantMap;
  }

  getResultMapFor96(): Map<string, CovidSamples> {
    let resultMap = new Map();
    for (let i = 0; i < this.columnHeaders384.length; i++) {
      for (let j = 0; j < this.rowHeaders384.length; j++) {
        let rowPosString = this.getRowColStringFromPos(j, i);
        if (this.plateMap.has(rowPosString) && this.selectedBatch.finalResult == "Report") {
          resultMap.set(rowPosString, this.plateMap.get(rowPosString));
        } else {
          resultMap.set(rowPosString, null);
        }
      }
    }
    return resultMap;
  }

  quadrantFromRowColPos(position: string) {
    let rowCol = this.getRowColumnNumberFromPosition(position);
    if (!this.isEven(rowCol[0]) && !this.isEven(rowCol[1])) {
      return Quadrant.A1;
    } else if (this.isEven(rowCol[0]) && !this.isEven(rowCol[1])) {
      return Quadrant.A2;
    } else if (!this.isEven(rowCol[0]) && this.isEven(rowCol[1])) {
      return Quadrant.B1;
    } else {
      return Quadrant.B2;
    }
  }

  isEven(num: number) {
    return num % 2 == 0;
  }

  getRowColumnNumberFromPosition(position: string): number[] {
    let row = position.charCodeAt(0) - 64;
    let col = parseInt(position.substring(1), 10);
    return [row, col];
  }

  initializeScanTable(mapOfPlatePositions: Map<string, CovidSamples>) {
    this.mapOfScannedBarcodes = new Map();
    this.scanTableBackupMap = new Map();
    this.currentScanCell = 0;
    this.scannedBarcode = '';
    this.activateSaveScan = false;
    this.scanTableArray = [];
    this.scannedControls = [];
    this.posControlsRemaining = this.posControlsForLab;
    this.contaminationPopUp = false;
    this.negativeControlRemaining = this.negativeControlForLab;
    for (let i = 0; i < 12; i++) {
      for (let j = 0; j < 8; j++) {
        let covidSample = new CovidSamples();
        covidSample.barcode = '';
        covidSample.positionRow = j + 1;
        covidSample.prositionCol = i + 1;
        covidSample.contaminationType = "No Contamination";
        let positionsString = this.getRowColStringFromPos(j, i);
        if (mapOfPlatePositions.has(positionsString)) {
          let sample = mapOfPlatePositions.get(positionsString);
          if (sample.barcode === 'POS_EX') {
            this.posControlsRemaining--;
            this.scannedControls.push(sample);
          } else if (sample.barcode === 'NTC_EX') {
            this.negativeControlRemaining--;
            this.scannedControls.push(sample);
          } else {
            this.mapOfScannedBarcodes.set(sample.barcode, positionsString);
          }
          covidSample = Object.assign({}, sample);
          this.scanTableBackupMap.set(sample.barcode, sample);
          this.currentScanCell = this.getPositionalValue(j, i);
        }
        this.scanTableArray.push(covidSample);
      }
    }
    if (this.plateMap.size > 0) {
      this.currentScanCell = this.currentScanCell !== 93 ? this.currentScanCell + 1 : this.currentScanCell;
    }
  }

  getPositionalValue(row: number, col: number) {
    return (col * 8) + row;
  }

  saveSamplesForBatch() {
    if (!this.isPUIDPresnt()) {
      this._messagesService.addWarningMessage({
        severity: 'warn', summary: 'USER ID not present!',
        detail: 'Please  enter USER ID before moving ahead',
      });
      return;
    }
    let scanArrayToSend = [];
    let scannedBarcodes = [];
    this.scanTableArray.forEach(sample => {
      if (sample.barcode && sample.barcode.trim() != '' && !['POS_EX', 'NTC_EX'].includes(sample.barcode)) {
        scanArrayToSend.push(sample);
        scannedBarcodes.push(sample.barcode);
      }
    });
    this.selectedBatch.scannedBarcodes = scannedBarcodes;
    this.selectedBatch.samples = scanArrayToSend;
    this.selectedBatch.sampleListSizeWithoutControls = scanArrayToSend.length;
    this.selectedBatch.statusOfTheBatch = 'START_CLIPPING';
    this.selectedBatch.previousStatusOfTheBatch = 'START_CLIPPING';
    this.selectedBatch.puidClipping = this.puid;
    this.selectedBatch.scannedControls = this.scannedControls.filter(sample => (sample != null && sample != undefined && sample.barcode && sample.barcode.trim() != ''));
    if (!this.selectedBatch.clippingStartDateTime) {
      this.selectedBatch.clippingStartDateTime = new Date();
    }
    this.apgTestingService.saveScannedSamples(this.selectedBatch).subscribe(
      result => {
        if (result.data) {
          this.selectedBatch = result.data;
          this._messagesService.addSuccessMessage({
            severity: 'success', summary: 'Samples Saved!',
            detail: 'All samples saved!',
          });
          this.createPlateMaps(this.selectedBatch.samples);
          this.initializeScanTable(this.plateMap);
          this.dirty = false;
          this.differentUnboxedErrorDisabled = false;
          this.activateSaveScan = false;
        }
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      }
    );
  }

  isScanningAllowed() {
    let scanAllowedStates = ['START_CLIPPING', 'COMPLETE_CLIPPING'];
    return scanAllowedStates.includes(this.selectedBatch.statusOfTheBatch);
  }

  focusScannedField() {
    this.scannedBarcode = '';
    this.focusOnCell();
  }

  moveFocus() {
    if (this.currentScanCell < 95 - this.totalPCRControls) {
      this.currentScanCell += 1;
      this.focusOnCell();
    }
  }

  getCurrentPositionString(positionValue: number) {
    if (positionValue >= 0) {
      let row = positionValue % 8;
      let col = Math.trunc(positionValue / 8);
      return this.getRowColStringFromPos(row, col);
    } else {
      return '';
    }
  }

  cellSelection(row: number, col: number) {
    let rowColString = this.getRowColStringFromPos(row, col);
    if (this.isScanningAllowed()) {
      let scanCell = this.getPositionalValue(row, col);
      if (scanCell > 95 - this.totalPCRControls) {
        this.scannedBarcode = '';
        return;
      }
      if (scanCell == this.currentScanCell
        && this.plateMap.has(rowColString)
        && this.scanTableBackupMap.has(this.plateMap.get(rowColString).barcode)) {
        this.selectedSample = this.scanTableArray[this.currentScanCell];
      } else {
        this.currentScanCell = scanCell;
        this.focusOnCell();
      }
      return;
    }
  }

  placePOSEXControl() {
    let currentPositionString = this.getCurrentPositionString(this.currentScanCell);
    if (this.posControlsRemaining > 0) {
      if (!this.scanTableArray[this.currentScanCell].barcode || this.scanTableArray[this.currentScanCell].barcode.trim() === '') {
        this.scanTableArray[this.currentScanCell] = this.getNewCovidSampleFromPosition((this.currentScanCell % 8), Math.trunc(this.currentScanCell / 8));
        this.scanTableArray[this.currentScanCell].barcode = 'POS_EX';
        this.plateMap.set(currentPositionString, Object.assign({}, this.scanTableArray[this.currentScanCell]));
        this.posControlsRemaining--;
        this.dirty = true;
        this.scannedControls.push(this.plateMap.get(currentPositionString));
        this.activateSaveScan = true;
        this.moveFocus();
      } else {
        this.scannedSampleErrorMessage = 'Occupied Position: Cannot insert POS_EX here.';
        this.showSampleErrorPopUp = true;
      }
    }
    this.focusOnCell();
  }

  placeNTCEXControl() {
    let currentPositionString = this.getCurrentPositionString(this.currentScanCell);
    if (this.negativeControlRemaining > 0) {
      if (!this.scanTableArray[this.currentScanCell].barcode || this.scanTableArray[this.currentScanCell].barcode.trim() === '') {
        this.scanTableArray[this.currentScanCell] = this.getNewCovidSampleFromPosition((this.currentScanCell % 8), Math.trunc(this.currentScanCell / 8));
        this.scanTableArray[this.currentScanCell].barcode = 'NTC_EX';
        this.plateMap.set(currentPositionString, Object.assign({}, this.scanTableArray[this.currentScanCell]));
        this.negativeControlRemaining--;
        this.dirty = true;
        this.scannedControls.push(this.plateMap.get(currentPositionString));
        this.activateSaveScan = true;
        this.moveFocus();
      } else {
        this.scannedSampleErrorMessage = 'Occupied Position: Cannot insert NTC_EX here.';
        this.showSampleErrorPopUp = true;
      }
    }
    this.focusOnCell();
  }

  focusOnCell() {
    this.scannedBarcode = this.scanTableArray[this.currentScanCell].barcode ? this.scanTableArray[this.currentScanCell].barcode : '';
    let element = document.getElementById("scanBarcode");
    element.focus();
  }

  verifyScan(barcode: string) {
    let currentPositionString = this.getCurrentPositionString(this.currentScanCell);
    let currentCellSample = Object.assign({}, this.scanTableArray[this.currentScanCell]);
    let isBeingReplaced = currentCellSample.barcode != barcode;
    let plateMapSample = this.plateMap.get(currentPositionString);
    if (barcode.trim() === '') {
      if (this.plateMap.has(currentPositionString)) {
        let scannedBarcode = plateMapSample.barcode;
        if (scannedBarcode === 'POS_EX') {
          this.posControlsRemaining++;
          this.scannedControls.splice(this.scannedControls.indexOf(plateMapSample), 1);
        } else if (scannedBarcode === 'NTC_EX') {
          this.negativeControlRemaining++;
          this.scannedControls.splice(this.scannedControls.indexOf(plateMapSample), 1);
        } else {
          this.mapOfScannedBarcodes.delete(scannedBarcode);
        }
        this.plateMap.delete(currentPositionString);
        this.scanTableArray[this.currentScanCell] = this.getNewCovidSampleFromPosition((this.currentScanCell % 8), Math.trunc(this.currentScanCell / 8));
        this.dirty = true;
        this.activateSaveScan = true;
      }
      this.moveFocus();
      return;
    }

    if (this.plateMap.has(currentPositionString) && plateMapSample.barcode !== barcode) {
      this.replacementHandler(plateMapSample);
    }

    if (barcode === 'POS_EX' || barcode === 'NTC_EX') {
      if (!this.plateMap.has(currentPositionString)) {
        if (barcode === 'POS_EX' && this.posControlsRemaining > 0) {
          this.posControlsRemaining--;
          this.scanTableArray[this.currentScanCell] = this.getNewCovidSampleFromPosition((this.currentScanCell % 8), Math.trunc(this.currentScanCell / 8));
          this.scanTableArray[this.currentScanCell].barcode = barcode;
          this.scannedControls.push(this.scanTableArray[this.currentScanCell]);
          this.dirty = true;
          this.addToScanTable(this.scanTableArray[this.currentScanCell]);
          return;
        } else if (barcode === 'NTC_EX' && this.negativeControlRemaining > 0) {
          this.negativeControlRemaining--;
          this.scanTableArray[this.currentScanCell] = this.getNewCovidSampleFromPosition((this.currentScanCell % 8), Math.trunc(this.currentScanCell / 8));
          this.scanTableArray[this.currentScanCell].barcode = barcode;
          this.scannedControls.push(this.scanTableArray[this.currentScanCell]);
          this.dirty = true;
          this.addToScanTable(this.scanTableArray[this.currentScanCell]);
          return;
        } else {
          this.focusScannedField();
          if (isBeingReplaced) {
            this.restoreBarcode(currentCellSample);
            this.focusOnCell();
          }
          this.scannedSampleErrorMessage = 'All ' + barcode + ' controls have already been added.';
          this.showSampleErrorPopUp = true;
          return;
        }
      } else {
        if (plateMapSample && plateMapSample.barcode === barcode) {
          this.moveFocus();
        } else {
          if (isBeingReplaced) {
            this.restoreBarcode(currentCellSample);
            this.focusOnCell();
          }
          this._messagesService.addWarningMessage({
            severity: 'warn', summary: 'Occupied Position!',
            detail: 'Cannot insert control here.',
          });
        }
        return;
      }
    }

    if (this.mapOfScannedBarcodes.has(barcode)) {
      if (currentPositionString === this.mapOfScannedBarcodes.get(barcode)) {
        this.moveFocus();
        return;
      }
      this.scannedSampleErrorMessage = barcode + ' has already been scanned at ' + this.mapOfScannedBarcodes.get(barcode);
      this.showSampleErrorPopUp = true;
      if (isBeingReplaced) {
        this.restoreBarcode(currentCellSample);
      }
      return;
    }

    if (this.scanTableBackupMap.has(barcode)) {
      this.scanTableArray[this.currentScanCell] = this.scanTableBackupMap.get(barcode);
      this.scanTableArray[this.currentScanCell].positionRow = (this.currentScanCell % 8) + 1;
      this.scanTableArray[this.currentScanCell].prositionCol = Math.trunc(this.currentScanCell / 8) + 1;
      this.mapOfScannedBarcodes.set(barcode, currentPositionString);
      this.plateMap.set(currentPositionString, Object.assign({}, this.scanTableArray[this.currentScanCell]));
      this._messagesService.addSuccessMessage({
        severity: 'success', summary: 'MOVED!',
        detail: barcode + ' has been moved',
      });
      this.moveFocus();
      return;
    }

    this.blocked = true;
    this.apgTestingService.validateScannedBarcode(barcode, this.selectedLabId).subscribe(
      result => {
        if (result.data == this.selectedBatch.batchID) {
          this._messagesService.addSuccessMessage({
            severity: 'success', summary: 'SCANNED!',
            detail: barcode + ' is OK',
          });
        } else {
          if (!this.differentUnboxedErrorDisabled) {
            this.scannedSampleErrorMessage = 'Sample ' + barcode + ' belongs to different batch ' + result.data;
            this.showDifferentUnboxedErrorPopUp = true;
          }
        }
        this.dirty = true;
        this.updateScanTableArray(barcode, currentPositionString, result.data);
        this.blocked = false;
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this.scannedSampleErrorMessage = barcode + ' ' + message.detail;
        this.showSampleErrorPopUp = true;
        if (isBeingReplaced) {
          this.restoreBarcode(currentCellSample);
        }
        this.blocked = false;
      }
    );
  }

  updateScanTableArray(barcode: string, currentPositionString: string, recievedBatchID: string) {
    this.scanTableArray[this.currentScanCell] = this.getNewCovidSampleFromPosition((this.currentScanCell % 8), Math.trunc(this.currentScanCell / 8));
    this.scanTableArray[this.currentScanCell].barcode = barcode;
    this.scanTableArray[this.currentScanCell].receivedBatchID = recievedBatchID;
    this.mapOfScannedBarcodes.set(barcode, currentPositionString);
    this.addToScanTable(this.scanTableArray[this.currentScanCell]);
  }

  addToScanTable(sample: CovidSamples) {
    this.plateMap.set(this.getCurrentPositionString(this.currentScanCell), Object.assign({}, sample));
    this.moveFocus();
    this.activateSaveScan = true;
  }

  getCellStyle(row: number, col: number) {
    let positionalValue = this.getPositionalValue(row, col);
    if (this.currentScanCell == positionalValue) {
      return {
        'border': '2px solid red',
        'border-radius': '4px',
        'background-color': '#86ff8a'
      };
    } else if (this.scanTableArray[positionalValue].barcode == 'POS_EX') {
      return {
        'background-color': 'aqua'
      };
    } else if (this.scanTableArray[positionalValue].barcode == 'NTC_EX') {
      return {
        'background-color': 'yellow'
      };
    } else if ((this.scanTableArray[positionalValue].barcode != '') && (this.scanTableArray[positionalValue].receivedBatchID != this.selectedBatch.batchID)) {
      return { 'background-color': '#fcc888' };
    } else if (this.isEven(row)) {
      return { 'background-color': '#d8fcff' };
    } else {
      return { 'background-color': 'white' };
    }
  }

  getColHeaderStyle(col: number) {
    if (this.isScanningAllowed()) {
      if (Math.trunc(this.currentScanCell / 8) == col) {
        return {
          'background-color': 'red'
        };
      }
    }
  }

  getRowHeaderStyle(row: number) {
    if (this.isScanningAllowed()) {
      if ((this.currentScanCell % 8) == row) {
        return {
          'background-color': 'red',
          'color': 'white'
        };
      }
    }
  }

  allControlsNotPresent() {
    let posControl = this.posControlsForLab;
    let negControl = this.negativeControlForLab;
    this.selectedBatch.samples.forEach(sample => {
      if (sample.barcode == 'POS_EX') {
        posControl--;
      } else if (sample.barcode == 'NTC_EX') {
        negControl--;
      }
    });

    if (posControl > 0) {
      return true;
    } else if (negControl > 0) {
      return true;
    } else {
      return false;
    }
  }

  commentsDisabledIf(contaminationType: string): boolean {
    return this.selectedSample.contaminationType != contaminationType;
  }

  saveContamination() {
    this.apgTestingService.saveContaminationInformation(this.selectedBatch.batchID, this.selectedSample, this.selectedBatch.lab).subscribe(
      result => {
        if (result.data) {
          this.contaminationPopUp = false;
          this.plateMap.set(this.getCurrentPositionString(this.currentScanCell), this.selectedSample);
          this._messagesService.addSuccessMessage({ severity: 'success', summary: 'Sample Updated', detail: result.data });
        }
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      }
    );
  }

  replacementHandler(sample: CovidSamples) {
    let currentPositionString = this.getCurrentPositionString(this.currentScanCell);
    if (sample.barcode === 'NTC_EX') {
      this.negativeControlRemaining++;
      this.scannedControls.splice(this.scannedControls.indexOf(sample), 1);
    } else if (sample.barcode === 'POS_EX') {
      this.posControlsRemaining++;
      this.scannedControls.splice(this.scannedControls.indexOf(sample), 1);
    } else {
      this.mapOfScannedBarcodes.delete(sample.barcode);
    }
    this.scanTableArray[this.currentScanCell] = this.getNewCovidSampleFromPosition((this.currentScanCell % 8), Math.trunc(this.currentScanCell / 8));
    this.plateMap.delete(currentPositionString);
    return;
  }

  restoreBarcode(sample: CovidSamples) {
    let currentPositionString = this.getCurrentPositionString(this.currentScanCell);
    let plateMapSample = this.plateMap.get(currentPositionString);
    this.scanTableArray[this.currentScanCell] = Object.assign({}, sample);
    if (sample.barcode === 'NTC_EX') {
      this.negativeControlRemaining--;
      this.scannedControls.push(plateMapSample);
    } else if (sample.barcode === 'POS_EX') {
      this.posControlsRemaining--;
      this.scannedControls.push(plateMapSample);
    } else {
      this.mapOfScannedBarcodes.set(sample.barcode, currentPositionString);
    }
    this.plateMap.set(currentPositionString, this.scanTableArray[this.currentScanCell]);
    return;
  }

  getNewCovidSampleFromPosition(row: number, col: number) {
    let sample = new CovidSamples();
    sample.positionRow = row + 1;
    sample.prositionCol = col + 1;
    sample.barcode = '';
    sample.contaminationType = 'No Contamination';
    return sample;
  }

  addChannelsToSample(samples: CovidSamples[]): CovidSamples[] {
    samples.forEach(sample => {
      sample.result = 'check';
      sample.channels = this.getChannel(sample.barcode, sample);
      sample.results = [];
      sample.inValidResult = false;
    });
    return samples;
  }

  getChannel(barcode: string, sample: CovidSamples): Channel[] {
    let pcrKit: any = this.getPcrKitFromMap(this.selectedBatch.rtPCRKitVendor);
    let channels = [];
    let icrChannelIndex: number = 0;
    if (pcrKit) {
      if (pcrKit.channel1Gene) {
        let channel = new Channel('');
        channel.gene = pcrKit.channel1Gene;
        channels.push(channel);
        if (['ICR', 'IPC'].includes(channel.gene)) {
          sample.icrChannelUpdateIndex = icrChannelIndex;
          //channel.gene = 'ICR';
        }
        icrChannelIndex++;
      }
      if (pcrKit.channel2Gene) {
        let channel = new Channel('');
        channel.gene = pcrKit.channel2Gene;
        channels.push(channel);
        if (['ICR', 'IPC'].includes(channel.gene)) {
          sample.icrChannelUpdateIndex = icrChannelIndex;
          //channel.gene = 'ICR';
        }
        icrChannelIndex++;
      }
      if (pcrKit.channel3Gene) {
        let channel = new Channel('');
        channel.gene = pcrKit.channel3Gene;
        channels.push(channel);
        if (['ICR', 'IPC'].includes(channel.gene)) {
          sample.icrChannelUpdateIndex = icrChannelIndex;
          //channel.gene = 'ICR';
        }
        icrChannelIndex++;
      }
      if (pcrKit.channel4Gene) {
        let channel = new Channel('');
        channel.gene = pcrKit.channel4Gene;
        channels.push(channel);
        if (['ICR', 'IPC'].includes(channel.gene)) {
          sample.icrChannelUpdateIndex = icrChannelIndex;
          //channel.gene = 'ICR';
        }
      }
      if (pcrKit.channel5Gene) {
        let channel = new Channel('');
        channel.gene = pcrKit.channel5Gene;
        channels.push(channel);
        if (['ICR', 'IPC'].includes(channel.gene)) {
          sample.icrChannelUpdateIndex = icrChannelIndex;
          //channel.gene = 'ICR';
        }
      }
      if (channels.length == 0) {
        let channel = new Channel(this.emptyGeneName);
        channels.push(channel);
      }

      channels.sort((channel1: Channel, channel2: Channel) => {
        return channel1.gene.localeCompare(channel2.gene);
      });
    }

    return channels;
  }

  allChannelsUpdated(sample: CovidSamples): boolean {
    let showResult = true;
    if (this.selectedBatch.resultUploaded && sample && sample.channels) {
      sample.channels.forEach(channel => {
        if (!channel.resultUploaded) {
          showResult = false;
        }
      });
      return showResult;
    } else {
      return false;
    }
  }

  getGeneFromFileName(fileName: string, pcrKitName: string) {
    let pcrKit: any = this.getPcrKitFromMap(pcrKitName);
    if (!pcrKit || (!pcrKit.channel1Gene && !pcrKit.channel2Gene && !pcrKit.channel3Gene && !pcrKit.channel4Gene && !pcrKit.channel5Gene)) {
      return this.emptyGeneName;
    } else {
      if (pcrKit.channel1Gene && this.fileEndChecker(pcrKit.channel1File, fileName)) {
        return pcrKit.channel1Gene;
      } else if (pcrKit.channel2Gene && this.fileEndChecker(pcrKit.channel2File, fileName)) {
        return pcrKit.channel2Gene;
      } else if (pcrKit.channel3Gene && this.fileEndChecker(pcrKit.channel3File, fileName)) {
        return pcrKit.channel3Gene;
      } else if (pcrKit.channel4Gene && this.fileEndChecker(pcrKit.channel4File, fileName)) {
        return pcrKit.channel4Gene;
      } else if (pcrKit.channel5Gene && this.fileEndChecker(pcrKit.channel5File, fileName)) {
        return pcrKit.channel5Gene;
      } else {
        return 'error';
      }
    }
  }

  fileEndChecker(endString: string, fileName: string): boolean {
    return fileName.includes(endString);
  }

  getChannelResult(sample: CovidSamples, channel: Channel) {
    return channel.geneResult;
  }

  getPcrKitFromMap(pcrKitName: string) {
    if (pcrKitName) {
      let mapKits = new Map(Object.entries(this.mapOfKits));
      let pcrKitMap = new Map(Object.entries(mapKits.get("pcr")));
      return pcrKitMap.get(pcrKitName);
    }
  }

  allChannelsUpdatedForBatch() {
    if (this.selectedBatch.resultUploaded && this.selectedBatch.samples && this.selectedBatch.samples.length > 0) {
      return this.allChannelsUpdated(this.selectedBatch.samples[0]);
    }
  }

  isContaminated(sample: CovidSamples): boolean {
    return (sample.contaminationType && sample.contaminationType != 'No Contamination') || (sample.comments && sample.comments.trim() != '');
  }

  isNCSample(sample: CovidSamples): boolean {
    return sample.nonConformanceProblem && sample.nonConformanceProblem.trim() != '' && sample.nonConformanceProblem != 'sampleOk';
  }

  getContaminationString(sample: CovidSamples): string {
    let comment = this.getContaminationComment(sample);
    return 'Contamination With: ' + comment + ' (' + sample.contaminationType + ')' + ' at ' + this.getContaminatedSamplePos(comment);
  }

  getContaminationComment(sample: CovidSamples): string {
    if (sample.contaminationType == 'Two Swabs')
      return sample.twoSwabsComment;
    else if (sample.contaminationType == 'Contamination')
      return sample.defaultContaminationComment;
    else
      return '';
  }

  getContaminatedSamplePos(sample: string): any {
    let position = '';
    this.plateMap.forEach((value, key) => {
      if (value.barcode == sample)
        position = key;
    });
    return position;
  }

  verifyIfSameBatch(textInput: HTMLInputElement) {
    if (this.selectedBatch.batchID == textInput.value) {
      this.scanBlock = false;
      this.sameScanBatch = true;
    } else {
      this._messagesService.addErrorMessage({ severity: 'error', summary: 'Batch Mismatch', detail: 'Scanned batch ' + textInput.value + ' does not match selected batch ' + this.selectedBatch.batchID });
    }
    textInput.value = null;
  }

  showBatchIDScannerIfDisabled() {
    if (!this.sameScanBatch) {
      this.scanBlock = true;
    }
  }

  clearScanBatchField(textInput: HTMLInputElement) {
    textInput.value = null;
  }

  getDominantChannelFromKit(pcrKitName: string) {
    let pcrKit: any = this.getPcrKitFromMap(pcrKitName);
    if (pcrKit) {
      return pcrKit.dominantChannel;
    }
    return null;
  }


  verifyAllSampleChecksResolved(sampleMap: Map<string, CovidSamples>, missingBarcodescheck: boolean) {
    this.missingBarcodesList = [];
    this.allChecksResolved = true;
    sampleMap.forEach((value: CovidSamples, key: string) => {
      if (value.results != undefined && value.results.length > 0) {
        value.results.forEach(result => {
          if (!this.isQuadrantIgnored(value) && result.sampleResult == 'check') {
            this.allChecksResolved = false;
          }
        });
      } else if (!this.isQuadrantIgnored(value) && value.result == 'check') {
        this.allChecksResolved = false;
      }
      if (missingBarcodescheck) {
        value.channels.forEach((channel) => {
          if (channel.gene === this.gene || (this.machineShortInfos.get(this.selectedBatch.machineName1) == APGCovid19Constants.bioradLimsMechine && this.uploadedxlsxFiles.length > 0)) {
            if (!channel.resultUploaded) {
              this.missingBarcodesList.push(value.barcode);
            }
          }
        });
      }
    });
  }

  isQuadrantIgnored(value: CovidSamples) {
    let quadrantIgnored = false;
    if (this.selectedBatch.wellType == WellType.WELL384) {
      this.selectedBatch.mergedBatches.forEach(mergedBatch => {
        if (mergedBatch.quadrant == value.quadrant && mergedBatch.finalResult != 'Report') {
          quadrantIgnored = true;
        }
      });
    } else if (this.selectedBatch.finalResult != 'Report') {
      quadrantIgnored = true;
    }
    return quadrantIgnored;
  }

  allNonICRChannelsUploaded() {
    let allChannelsUploaed = true;
    if (this.selectedBatch.samples && this.selectedBatch.samples.length > 0) {
      let sample = this.selectedBatch.samples[0];
      if (sample.channels) {
        sample.channels.forEach(channel => {
          if (channel.gene != 'ICR' && !channel.resultUploaded) {
            allChannelsUploaed = false;
          }
        });
      }
    }
    return allChannelsUploaed;
  }

  isChannelDominant(channelName: string): boolean {
    return channelName == this.dominantChannelName;
  }

  getResultOptions(sample: CovidSamples): SelectItem[] {
    if (['NTC_EX', 'PCR-NTC'].includes(sample.barcode)) {
      return this.negativeControlResultOptions;
    } else if (['POS_EX', 'PCR-PC'].includes(sample.barcode)) {
      return this.positiveControlResultOptions;
    } else {
      if (this.sampleHasPositiveBlock(sample, 'N-Gene', 39)) {
        return this.sampleResultOptionsWithoutPositive;
      } else {
        return this.sampleResultOptions;
      }
    }
  }

  sampleHasPositiveBlock(sample: CovidSamples, geneName: string, blockerValue: number) {
    let channels = sample.channels;
    let block = false;
    if (channels && channels.length > 0) {
      channels.forEach(channel => {
        if (channel.gene == geneName && (!channel.cpValue || channel.cpValue > blockerValue)) {
          block = true;
        }
      });
    }
    return block;
  }

  proceedToCompleteAnalysis() {
    return ((this.selectedBatch.statusOfTheBatch == 'ANALYSIS_STARTED' || this.selectedBatch.statusOfTheBatch == 'ANALYSIS_DONE') && (
      (this.allChannelsUpdatedForBatch() && this.allChecksResolved) || this.reportingOutsideBB))
  }



  getResultOptionsForChannel(sampleBarcode: string): SelectItem[] {
    return (['NTC_EX', 'PCR-NTC'].includes(sampleBarcode)) ? this.icrResultOptionsNegative : this.icrResultOptionsNormal;
  }

  getResultValues(result: string): SelectItem[] {
    let dropdownValues = [
      { value: result, label: result },
      { value: 'artifact', label: 'artifact' }
    ];
    return dropdownValues;
  }
  showCommentsInClipping() {
    return (this.isScanningAllowed() && this.val2 === '96 Detail');
  }

  convertStringToUTF8ByteArray(str) {
    var data = [];
    for (var i = 0; i < str.length; i++) {
      data.push(str.charCodeAt(i));
    }
    return data;
  }

  getBoxColour(quad: string) {
    if (quad == "A1") {
      return { 'outline-color': '#5858fa' }
    }
    if (quad == "A2") {
      return { 'outline-color': '#ff9000' }
    }
    if (quad == "B1") {
      return { 'outline-color': '#39ff14' }
    }
    if (quad == "B2") {
      return { 'outline-color': '#886a08' }
    }
  }

  getBoxColour1(finalResultForQuad: number) {
    let colorCheck384 = '';
    if (this.selectedBatch.mergedBatches &&
      this.selectedBatch.mergedBatches[finalResultForQuad].finalResult &&
      this.selectedBatch.mergedBatches[finalResultForQuad].finalResult !== 'Report'
      && !this.selectedBatch.mergedBatches[finalResultForQuad].redoReason
      && !this.selectedBatch.mergedBatches[finalResultForQuad].redone) {
      colorCheck384 = 'Red';
    }
    return colorCheck384;
  }

  getBoxColourFor96() {
    let colorCheck96 = '';
    if (this.selectedBatch.finalResult && this.selectedBatch.finalResult !== 'Report' && !this.selectedBatch.redoReason) {
      colorCheck96 = 'Red';
    }
    return colorCheck96;
  }

  getFontColorFor96() {
    let fontColorCheck96 = 'Black';
    if (this.selectedBatch.finalResult && this.selectedBatch.finalResult !== 'Report' && !this.selectedBatch.redoReason) {
      fontColorCheck96 = 'White';
    }
    return fontColorCheck96;
  }

  getFontColorFor384(finalResultForQuad: number) {
    let fontColorCheck384 = 'Black';
    if (this.selectedBatch.mergedBatches &&
      this.selectedBatch.mergedBatches[finalResultForQuad].finalResult &&
      this.selectedBatch.mergedBatches[finalResultForQuad].finalResult !== 'Report'
      && !this.selectedBatch.mergedBatches[finalResultForQuad].redoReason
      && !this.selectedBatch.mergedBatches[finalResultForQuad].redone) {
      fontColorCheck384 = 'White';
    }
    return fontColorCheck384;
  }

  setRedoReason() {
    if (this.selectedBatch.wellType == 'WELL96') {
      this.selectedBatch.redoReason = this.selectedRedoReason != 'Other' ? this.selectedRedoReason : this.enteredRedoReason;
      this.selectedBatch.redoStep = this.selectedBatch.finalResult;
    } else {
      this.selectedMergedBatch.redoReason = this.selectedRedoReason != 'Other' ? this.selectedRedoReason : this.enteredRedoReason;
    }
    this.redoReasonsPopup = false;
  }

  checkIfFinalResultIsRedo(finalResult: string) {
    return (finalResult && finalResult != 'Report');
  }

  checkIfFinalResultIsCheck(finalResult: string) {
    return finalResult != 'Check';
  }

  showRedoReasonPopup(index: number) {
    this.selectedRedoReason = null;
    this.enteredRedoReason = null;
    this.selectedMergedBatch = this.selectedBatch.mergedBatches[index];
    if (this.selectedMergedBatch.redoReason) {
      this.redoReasons.forEach(reason => {
        if (reason.value == this.selectedMergedBatch.redoReason)
          this.selectedRedoReason = reason.value;
      });
      if (!this.selectedRedoReason) {
        this.selectedRedoReason = 'Other';
        this.enteredRedoReason = this.selectedMergedBatch.redoReason;
      }
    }
    this.redoReasonsPopup = true;
  }

  getLinkColorFor96() {
    let fontColorCheck96 = 'Blue';
    if (this.selectedBatch.finalResult && this.selectedBatch.finalResult !== 'Report' && !this.selectedBatch.redoReason) {
      fontColorCheck96 = 'Yellow';
    }
    return fontColorCheck96;
  }

  getLinkColorFor384(index: number) {
    let fontColorCheck384 = 'Blue';
    if (this.selectedBatch.mergedBatches &&
      this.selectedBatch.mergedBatches[index].finalResult &&
      this.selectedBatch.mergedBatches[index].finalResult !== 'Report'
      && !this.selectedBatch.mergedBatches[index].redoReason
      && !this.selectedBatch.mergedBatches[index].redone) {
      fontColorCheck384 = 'Yellow';
    }
    return fontColorCheck384;
  }

  redoButtonDisabledIf() {
    if (!this.selectedRedoReason)
      return true;
    else if (this.selectedRedoReason != 'Other')
      return false;
    else
      return !(this.enteredRedoReason && this.enteredRedoReason.trim() != '');
  }

  resultReportDownload(batchID: string) {
    this.blocked = true;
    this.apgTestingService.resultReportExcelDowload(batchID, this.selectedLabId).subscribe(
      result => {
        this.blocked = false;
        var blob = new Blob([result.fileContent], { type: 'application/octet-stream' });
        let filename = batchID + '_' + this.puid + '_report.xlsx'
        this.saveFile(blob, filename);
      },
      error => {
        this.handleError(error);
      }
    );
  }

  getChannelResultForAnalysisTable(sample: CovidSamples, channelName: string) {
    let geneValue = null;
    sample.channels.forEach(channel => {
      if (channel.gene == channelName) {
        geneValue = channel.cpValue;
      }
    });
    return geneValue;
  }

  isAnalysisConfirmDisabled() {
    let isInvalidverifyPUID = this.invalidVerifyPUIDCheck();
    return (!this.analysisVerifyPUID || this.analysisVerifyPUID.trim() == '' || !this.enteredPassword || this.enteredPassword.trim() == '' || isInvalidverifyPUID);
  }

  clearVerificationPUID() {
    this.showAnalysisDialog = false;
    this.analysisVerifyPUID = null;
    this.enteredPassword = null;
  }

  invalidVerifyPUIDCheck() {
    return (this.analysisVerifyPUID && this.puid && (this.analysisVerifyPUID.toLowerCase() === this.puid.toLowerCase()));
  }

  getFinalStatusList(mergedBatch: MergedBatch) {
    if (this.selectedBatch.wellType == WellType.WELL96) {
      if (this.selectedBatch.redoCount == 0 || this.selectedBatch.swabType !== 'Dry')
        return this.finalStatusList;
      else {
        return this.selectedBatch.batchID.substring(this.selectedBatch.batchID.lastIndexOf('_')).includes('L') ? this.finalStatusListWithoutLysis : this.finalStatusList;
      }
    } else {
      return mergedBatch.redoLysisDone ? this.finalStatusListWithoutLysis : this.finalStatusList;
    }
  }

  getRedoReason(mergedBatch: MergedBatch) {
    let redoReason: string = '';
    if (mergedBatch.finalResult != 'Report' && mergedBatch.redoReason) {
      this.redoReasons.forEach(reason => {
        if (reason.value == mergedBatch.redoReason)
          redoReason = reason.value;
      });
      if (redoReason == '') {
        redoReason = 'Other';
      }
    }
    return redoReason;
  }
  checkIfAllMandatoryFilesUploaded() {
    let missingPatterns: any[] = [];
    Array.from(this.manufacturerFileMandatoryMap.keys()).forEach(key => {
      let mandatoryPatterns = this.manufacturerFileMandatoryMap.get(key);
      mandatoryPatterns.forEach(filePattern => {
        let filesUploadedForFormat = this.filesPerManufacturerMap.get(key);
        let isPatternUploaded = false;
        if (filesUploadedForFormat) {
          filesUploadedForFormat.forEach(file => {
            let pattern = filePattern.pattern.replace("<batchID>", this.selectedBatch.batchID);
            if (file.fileName.includes(pattern)) {
              isPatternUploaded = true;
            }
          });
        }
        if (!isPatternUploaded)
          missingPatterns.push(filePattern);
      });
    });
    return missingPatterns;
  }

  getChannelTestingMapper() {
    let channelTestingTypeList = [];
    let sample = this.getFirstValidSample(this.selectedBatch.samples);
    let channelTestingTypeMap = new ChannelTestingTypeMapping();
    if (sample.results && sample.results.length > 0) {
      sample.results.forEach(result => {
        channelTestingTypeMap.diseaseName = result.testingType;
        channelTestingTypeMap.channelAssosiatedToDisease = [];
        let resultType = this.resultGroupMap[result.testingType];
        if (resultType) {
          if (resultType['channelThreshold']) {
            resultType['channelThreshold'].forEach(channel => {
              channelTestingTypeMap.channelAssosiatedToDisease.push(channel.channelName)
            });
          }
        }
        channelTestingTypeList.push(Object.assign({}, channelTestingTypeMap));
      });
    } else {
      channelTestingTypeMap.diseaseName = "Covid";
      channelTestingTypeMap.channelAssosiatedToDisease = [];
      if (sample.channels) {
        sample.channels.forEach(channel => {
          channelTestingTypeMap.channelAssosiatedToDisease.push(channel.gene);
        });
      }
      channelTestingTypeList.push(Object.assign({}, channelTestingTypeMap));
    }
    return channelTestingTypeList;
  }

  getFirstValidSample(samples: CovidSamples[]) {
    for (let i = 0; i < samples.length; i++) {
      if (!this.controlArray.includes(samples[i].barcode)) {
        return samples[i];
      }
    }
  }

  getSelectedSampleHistoryMap(barcode: string) {
    if (this.sampleHistoryMap && !this.controlArray.includes(barcode)) {
      let sampleHistory = this.sampleHistoryMap[barcode];
      let sampleHistoryMap = new Map<string, Object>();
      if (sampleHistory && sampleHistory.length > 0) {
        sampleHistory.forEach(history => {
          if (history.channelTestingTypeMapping && history.channelTestingTypeMapping.length > 0 && (history.samples.result || (history.samples.results && history.samples.results.length > 0))) {
            this.batchHeaders.push(history['batchID']);
            sampleHistoryMap.set(history['batchID'], history);
          }
        });
        return sampleHistoryMap;
      }
      return null;
    }
    return null;
  }

  getHistoryForCurrentBatch(batchID: string) {
    if (this.selectedSampleHistoryMap && this.selectedSampleHistoryMap.size > 0) {
      return this.selectedSampleHistoryMap.get(batchID);
    }
    return null;
  }
  onRightDirectionClick() {
    this.headerIndex = this.headerIndex + 1;
    this.reset = [{}];
  }

  onLeftDirectionClick() {
    this.headerIndex = this.headerIndex - 1;
    this.reset = [{}];
  }

  isRightDirectionClickDisabled() {
    return (!this.analysisAndUpwardsStatuses.includes(this.selectedBatch.statusOfTheBatch) || this.headerIndex == (this.batchHeaders.length - 1));
  }

  isLeftClickDirectionDisabled() {
    return (!this.analysisAndUpwardsStatuses.includes(this.selectedBatch.statusOfTheBatch) || this.headerIndex == 0);
  }

  getSubSenders() {
    this.selectedBatch.samples.forEach(sample => {
      this.subSender.add(sample.unboxedSender);
    });
  }

  getSubSendersForPlateOne() {
    this.selectedBatch.samples.forEach(sample => {
      if (sample.receivedBatchID == this.plateOne) {
        this.subSenderForPlateOne.add(sample.unboxedSender);
      }
    });
  }

  getSubSendersForPlateTwo() {
    this.selectedBatch.samples.forEach(sample => {
      if (sample.receivedBatchID == this.plateTwo) {
        this.subSenderForPlateTwo.add(sample.unboxedSender);
      }
    });
  }

  getSubSendersForPlateThree() {
    this.selectedBatch.samples.forEach(sample => {
      if (sample.receivedBatchID == this.plateThree) {
        this.subSenderForPlateThree.add(sample.unboxedSender);
      }
    });
  }

  getSubSendersForPlateFour() {
    this.selectedBatch.samples.forEach(sample => {
      if (sample.receivedBatchID == this.plateFour) {
        this.subSenderForPlateFour.add(sample.unboxedSender);
      }
    });
  }


  assignRandomLightColour(i: number, sub: string) {
    return {
      'color': this.generateRandomLightColour(i, sub)
    };
  }

  generateRandomLightColour(i: number, sub: string) {
    let senderColor: string;
    if (i > this.colours.length - 1) {
      i = i % 10;
    }
    senderColor = this.colours[i];

    if (sub) {
      this.colorSenderMap.set(sub, senderColor);
    }
    return senderColor;
  }

  getSampleColorByUnboxedSender(sub: string) {
    let bgColorSender = this.colorSenderMap.get(sub);
    if (!bgColorSender) {
      return {
        'background-color': '#FFFFFF'
      };
    }
    else {
      return {
        'background-color': bgColorSender
      };
    }
  }

  completeAnalysisForReportingOutsideProcess() {
    let isRedoReasonSelected = true;
    if (this.selectedBatch.wellType == WellType.WELL384) {
      this.selectedBatch.mergedBatches.forEach(mergedBatch => {
        if (mergedBatch.finalResult != 'Report' && !mergedBatch.redoReason)
          isRedoReasonSelected = false;
      });

    } else {
      isRedoReasonSelected = !(this.selectedBatch.finalResult != 'Report' && !this.selectedBatch.redoReason);

    }
    if (!isRedoReasonSelected) {
      this._messagesService.addErrorMessage({
        severity: 'error', summary: 'Redo Reason Not Selected!',
        detail: 'Please Select Redo Reason for Each Batch Set for Redo',
      });
      this.blocked = false;
      return;
    }
    this.selectedBatch.resultSentDateTime = new Date();
    this.selectedBatch.statusOfTheBatch = 'COMPLETED';
    this.selectedBatch.previousStatusOfTheBatch = 'COMPLETED';
    this.apgTestingService.confirmPlates(this.selectedBatch, this.reportingOutsideBB).subscribe(
      result => {
        if (result.data) {
          this.selectedBatch = result.data;
          this._messagesService.addSuccessMessage({
            severity: 'success', summary: 'Completed batch!',
            detail: 'Successfully completed batch',
          });
        }
        this.blocked = false;
      },
      error => {
        this.selectedBatch.resultSentDateTime = null;
        this.selectedBatch.resultDispatchedyPUID = '';
        this.selectedBatch.statusOfTheBatch = 'ANALYSIS_STARTED';
        this.selectedBatch.previousStatusOfTheBatch = 'ANALYSIS_STARTED';
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
        this.blocked = false;
      }
    );
  }


  isPUIDPresnt() {
    if (this.puid != null && this.puid != undefined && this.puid != '') {
      return true;
    }
    return false;
  }

  saveFile(data: any, filename?: string) {
    const blob = new Blob([data], { type: 'application/octet-stream' });
    saveByFileSaver(blob, filename);
  }

  getCellBackgroundColor(i, j) {
    let defaultColor = 'white';
    let positionString = this.getRowColStringFromPos(i, j);
    if (this.plateMap.has(positionString)) {
      let results: ResultMapper[] = this.val2 == 'Artic' ? this.plateMap.get(positionString).articQC : this.plateMap.get(positionString).libQC;
      let lastResult: ResultMapper = results[results.length - 1];
      if (colorMap.has(lastResult.result))
        return colorMap.get(lastResult.result);
    }
    return defaultColor;
  }

  getSampleConcentration(i, j) {
    let positionString = this.getRowColStringFromPos(i, j);
    if (this.plateMap.has(positionString)) {
      let results: ResultMapper[] = this.val2 == 'Artic' ? this.plateMap.get(positionString).articQC : this.plateMap.get(positionString).libQC;
      let lastResult: ResultMapper = results[results.length - 1];
      return lastResult.concentration;
    }
    return '';
  }

  getSampleCaluclatedConcentration(i, j) {
    let positionString = this.getRowColStringFromPos(i, j);
    if (this.plateMap.has(positionString)) {
      let results: ResultMapper[] = this.val2 == 'Artic' ? this.plateMap.get(positionString).articQC : this.plateMap.get(positionString).libQC;
      let lastResult: ResultMapper = results[results.length - 1];
      return lastResult.calculatedValue;
    }
    return '';
  }

  getLastUploadedDF(i, j) {
    let positionString = this.getRowColStringFromPos(i, j);
    if (this.plateMap.has(positionString)) {
      let results: ResultMapper[] = this.val2 == 'Artic' ? this.plateMap.get(positionString).articQC : this.plateMap.get(positionString).libQC;
      let lastResult: ResultMapper = results[results.length - 1];
      return lastResult.dilutedSolution;
    }
    return '';
  }

  disableToolTipIf(i, j) {
    let positionString = this.getRowColStringFromPos(i, j);
    return !(this.plateMap.has(positionString));
  }

  getToolTip(i, j) {
    return 'Barcode: ' + this.getSampleAt(i, j, this.plateMap).barcode + '<br/>' + 'MV: ' + this.getSampleConcentration(i, j) + '<br/>' + 'DF: ' + this.getLastUploadedDF(i, j);
  }

  getReadCountCellBackgroundColor(i, j) {
    let lastValueResults;
    let defaultColor = 'white';
    let positionString = this.getRowColStringFromPos(i, j);
    if (this.plateMap.has(positionString)) {
      let sample = this.plateMap.get(positionString);
      if (sample.numberReads && sample.numberReads.length > 0) {
        let results: ResultMapperRead[] = sample.numberReads;
        let lastResult: ResultMapperRead = results[results.length - 1];
        lastValueResults = lastResult.read;
      }
      if (lastValueResults) {
        let plannedReads = 500000;
        if (lastValueResults >= (plannedReads * 2))
          return '#4ea3d8'
        else if ((lastValueResults < (plannedReads * 2)) && (lastValueResults >= (plannedReads * 0.2)))
          return '#8DBC7A'
        else if ((lastValueResults < (plannedReads * 0.2)) && (lastValueResults >= (plannedReads * 0.03)))
          return '#FFFF40';
        else if (lastValueResults < (plannedReads * 0.03))
          return '#E88D8D';
      } else {
        return '#E88D8D';
      }
    }
    return defaultColor;
  }

  getPrimaryAnalysisReadCount(i, j) {
    let positionString = this.getRowColStringFromPos(i, j);
    if (this.plateMap.has(positionString)) {
      let sample = this.plateMap.get(positionString);
      if (sample && Object.keys(sample).length > 0 && sample.numberReads && sample.numberReads.length > 0) {
        let results: ResultMapperRead[] = sample.numberReads;
        let lastResult: ResultMapperRead = results[results.length - 1];
        const filterPipe = new NumberFormatPipe();
        let latestReadCountValue = lastResult.read === 0 ? 'NA' : lastResult.read;
        return filterPipe.transform(latestReadCountValue);
      } else {
        return '0';
      }
    }
    return '';
  }

  toggelAnalysisView() {

    this.analysisPlateView = !this.analysisPlateView
    if (this.analysisPlateView) {
      this.getAnalysisView();
    } else if (this.selectedBatch.measuredLibQCDateTime) {
      this.val2 = 'Library';
    } else if (this.selectedBatch.measuredArticQCDateTime) {
      this.val2 = 'Artic';
    } else {
      this.val2 = 'Plate';
    }
    if(Array.from(this.mapOfQCReviewsForNumberReads.keys()).length > 0 || Array.from(this.mapOfQCReviewsForMetricsMerged.keys()).length > 0){
      this.onManualQCReviewClicked(this.mapOfQCReviewsForNumberReads, 'numberReads');
      this.onManualQCReviewClicked(this.mapOfQCReviewsForMetricsMerged, 'metricsMerged');
    }
  }

  getBGColorForSampleAndPositiveCellValues(coverageBreadth) {
    let positiveCellColor = '#fff';
    if (coverageBreadth >= 94) {
      positiveCellColor = '#ADD8E6';
    } else if (coverageBreadth >= 90 && coverageBreadth < 94) {
      positiveCellColor = '#90EE90';
    } else if (coverageBreadth >= 30 && coverageBreadth < 90) {
      positiveCellColor = '#FFFF40';
    } else if (coverageBreadth < 30) {
      positiveCellColor = '#ff6347';
    }
    return positiveCellColor;
  }

  getBGColorForNagitiveControlCellValues(coverageBreadth) {
    let negativeCellColor = '#fff';
    if (coverageBreadth >= 90) {
      negativeCellColor = '#ff6347';
    } else if (30 <= coverageBreadth && coverageBreadth < 90) {
      negativeCellColor = '#FFFF40';
    } else if (10 <= coverageBreadth && coverageBreadth < 30) {
      negativeCellColor = '#90EE90';
    } else if (coverageBreadth < 10) {
      negativeCellColor = '#ADD8E6';
    }
    return negativeCellColor;
  }

  getCellBackgroundColorOfMeanCoverage(i, j) {
    let cellColorCode = '#fff';
    let coverageBreadth;
    let positionString = this.getRowColStringFromPos(i, j);
    if (this.plateMap.has(positionString)) {
       let sample = this.plateMap.get(positionString);
       this.sampleBarcodeName=sample.barcode
      if (sample && Object.keys(sample).length > 0 && sample.metricsMergedResults && sample.metricsMergedResults.length > 0) {
        let results: ResultMapperMetricsMerged[] = sample.metricsMergedResults;
        let lastResult: ResultMapperMetricsMerged = results[results.length - 1];
        coverageBreadth = lastResult.percentRefCovered;
      }
    }
    if (this.sampleBarcodeName && !this.sampleBarcodeName.endsWith('_NTC')) {
      cellColorCode = this.getBGColorForSampleAndPositiveCellValues(coverageBreadth);
    } else if (this.sampleBarcodeName && this.sampleBarcodeName.endsWith('_NTC')) {
      cellColorCode = this.getBGColorForNagitiveControlCellValues(coverageBreadth);
    }
    return cellColorCode;
  }


  getSecondaryAnalysisCoverageBreadth(i, j) {
    let coverageBreadthValue = '';
    let positionString = this.getRowColStringFromPos(i, j);
    if (this.plateMap.has(positionString)) {
      let sample = this.plateMap.get(positionString);
      if (sample && Object.keys(sample).length > 0 && sample.metricsMergedResults && sample.metricsMergedResults.length > 0) {
        let results: ResultMapperMetricsMerged[] = sample.metricsMergedResults;
        let lastResult: ResultMapperMetricsMerged = results[results.length - 1];
        return lastResult.percentRefCovered + "%";
      } else {
        return '0';
      }
    }
    return coverageBreadthValue;
  }

  getSecondaryAnalysisMeanCoveragevalue(i, j) {
    let meanCovergaeValue = '';
    let positionString = this.getRowColStringFromPos(i, j);
    if (this.plateMap.has(positionString)) {
      let sample = this.plateMap.get(positionString);
      if (sample && Object.keys(sample).length > 0 && sample.metricsMergedResults && sample.metricsMergedResults.length > 0) {
        let results: ResultMapperMetricsMerged[] = sample.metricsMergedResults;
        let lastResult: ResultMapperMetricsMerged = results[results.length - 1];
        return lastResult.meanCoverage;
      } else {
        return '0';
      }
    }
    return meanCovergaeValue;
  }

  getUnderminedReads() {
    return this.numberFormatPipe.transform(this.selectedBatch.undeterminedReads);
  }

  downloadHtmlFile(){
    var folderPath=this.getFolderPath(this.selectedBatch.secondaryAnalysisHtmlPath);
    this.apgTestingService.downloadSecondaryAnalysisFile(folderPath,this.htmlfileName).subscribe( 
        result => {
          var blob = new Blob([result.body], { type: 'html' });
          if(blob.size!=0){
            this.saveFile(blob, this.htmlfileName);
            this._messagesService.addSuccessMessage({
              severity: 'success', summary: 'Download is successful',
              detail: 'Secondary Analysis html file has been downloaded',
            });
          }else{
            this._messagesService.addErrorMessage({
              severity: 'error', summary: 'Download Failed',
              detail: 'Secondary Analysis html file has been deleted',
            });
          }
        },
        error => {
          this._messagesService.addErrorMessage({
            severity: 'error', summary: 'Download Failed',
            detail: 'Secondary Analysis html file has been deleted',
          });
        }
    )
  }

  getSecondaryAnalysisFileName(fileName:string){
    if(fileName!=null){
      var splitted = fileName.split("/", 7); 
      return splitted[splitted.length-1];
    }
  }

  getFolderPath(filePath: string) {
    if (filePath != null) {
      var splitted = filePath.split("/", 7);
      return splitted[splitted.length - 2];
    }
  }

  getAnalysisView() {
    if (this.selectedBatch.primaryAnalysisImportedDateTime) {
      this.val2 = 'Read Counts';
    } else if (this.selectedBatch.metricsResultsImportedDateTime) {
      this.val2 = 'Mean coverage/Coverage breadth'
    } else if(this.selectedBatch.pangolianResultsImportedDateTime){
      this.val2 = 'Lineage classification'
    } else {
      this.val2 = 'Batch QC Report';
    }

  }


  
  getSecondaryAnalysisPangolianLeneageValue(i, j) {
    let meanCovergaeValue = '';
    let positionString = this.getRowColStringFromPos(i, j);

    if (this.plateMap.has(positionString)) {
      let sample = this.plateMap.get(positionString);
        if (sample && Object.keys(sample).length > 0 && sample.linageClassification && sample.linageClassification.length > 0) {
          let results: ResultPangolianMapper[] = sample.linageClassification;
          let lastResult: ResultPangolianMapper = results[results.length - 1];
          return  lastResult.linage;
        } else {
          return ' ';
        }
    }
    return meanCovergaeValue;
  }

  getSecondaryAnalysisPangolianLeneageSnpValue(i, j) {
    let meanCovergaeValue = '';
    let positionString = this.getRowColStringFromPos(i, j);

    if (this.plateMap.has(positionString)) {
      let sample = this.plateMap.get(positionString);
        if (sample && Object.keys(sample).length > 0 && sample.linageClassification && sample.linageClassification.length > 0) {
          let results: ResultPangolianMapper[] = sample.linageClassification;
          let lastResult: ResultPangolianMapper = results[results.length - 1];
          return  lastResult.note;
        } else {
          return ' ';
        }
    }
    return meanCovergaeValue;
  }

  getCellBackgroundColorOfLinageClassification(i, j) {
    let cellColorCode = '#ffff';
    let coverageBreadth;
    let positionString = this.getRowColStringFromPos(i, j);
    if (this.plateMap.has(positionString)) {
      let sample = this.plateMap.get(positionString);
      if (sample && Object.keys(sample).length > 0 && sample.linageClassification && sample.linageClassification.length > 0) {
        let results: ResultPangolianMapper[] = sample.linageClassification;
        let lastResult: ResultPangolianMapper = results[results.length - 1];
        coverageBreadth = lastResult.linage;
        if(this.pangolianPieColorMap.get(coverageBreadth)!=null){
          if(coverageBreadth=='NA'){
             return cellColorCode;
          }else if(lastResult.status=='fail'){
           return this.pangolianPieColorMap.get("qc failed");
          }
          return this.pangolianPieColorMap.get(coverageBreadth);
        }
      }
    }
   return cellColorCode;
  }

  checkIfQCFailedForReadCount(i: number, j: number) {
    let positionString = this.getRowColStringFromPos(i, j);
    if (this.plateMap.has(positionString)) {
      let sample = this.plateMap.get(positionString);
      if (sample.qcFailedResultWithReason)
        return sample.qcFailedResultWithReason.numberReadsFailed;
      return false;
    }
    return false;
  }

  checkIfQCFailedForMeanCoverage(i: number, j: number){
    let positionString = this.getRowColStringFromPos(i, j);
    if (this.plateMap.has(positionString)) {
      let sample = this.plateMap.get(positionString);
      if (sample.qcFailedResultWithReason)
        return sample.qcFailedResultWithReason.mergeMetricsFailed;
      return false;
    }
    return false;
  }

  onCheckBoxValueChangeForReadCount(e, i: number, j: number) {
    let positionString = this.getRowColStringFromPos(i, j);
    if (this.plateMap.has(positionString)) {
      let sample = this.plateMap.get(positionString);
      if(this.mapOfQCReviewsForNumberReads.has(sample.barcode))
        this.mapOfQCReviewsForNumberReads.delete(sample.barcode);
      else{
        let results: ResultMapperRead[] = sample.numberReads;
        let lastResult: ResultMapperRead = results[results.length - 1];
        let newResult = {...lastResult};
        newResult.qcFailed = e.target.checked;
        newResult.qcReviewer = this.puid;
        newResult.qcReviewTimestamp = new Date();
        newResult.qcFailedReason = e.target.checked ? 'Read Count' : 'NA';
        this.mapOfQCReviewsForNumberReads.set(sample.barcode,newResult);
      }
      if(Array.from(this.mapOfQCReviewsForNumberReads.keys()).length > 0){
        this.valueChange.emit({"dirtyChild":true});
      }else {
        this.valueChange.emit({"dirtyChild":false});
      }
    }
  }

  onCheckBoxValueChangeForMeanCoverage(e, i: number, j: number){
    let positionString = this.getRowColStringFromPos(i, j);
    if (this.plateMap.has(positionString)) {
      let sample = this.plateMap.get(positionString);
      if(this.mapOfQCReviewsForMetricsMerged.has(sample.barcode))
        this.mapOfQCReviewsForMetricsMerged.delete(sample.barcode);
      else{
        let results: ResultMapperMetricsMerged[] = sample.metricsMergedResults;
        let lastResult: ResultMapperMetricsMerged = results[results.length - 1];
        let newResult = {...lastResult};
        newResult.qcFailed = e.target.checked;
        newResult.qcReviewer = this.puid;
        newResult.qcReviewTimestamp = new Date();
        newResult.qcFailedReason = e.target.checked ? 'Mean Coverage/Coverage Breadth' : 'NA';
        this.mapOfQCReviewsForMetricsMerged.set(sample.barcode,newResult);
      }
        if(Array.from(this.mapOfQCReviewsForMetricsMerged.keys()).length > 0){
          this.valueChange.emit({"dirtyChild":true});
        }else {
          this.valueChange.emit({"dirtyChild":false});
        }
      }
  }
  disableSaveQCForReadCount(){
   return !(this.manualQCReviewMode && Array.from(this.mapOfQCReviewsForNumberReads.keys()).length !== 0);
  }

  sampleExistsAt( i: number, j: number){
    let positionString = this.getRowColStringFromPos(i, j);
    return this.plateMap.has(positionString)
  }

  public onChange(): Covid19Batch{
    return this.selectedBatch;
  }

  saveQCReviews(qcReviewMode: string){
    let manualQCReviewRequest: ManualQCReviewRequest = new ManualQCReviewRequest();
    if(qcReviewMode == 'numberReads'){
      let numberReads = {}; 
      this.mapOfQCReviewsForNumberReads.forEach((v: ResultMapperRead, k:string) => numberReads[k]=v);
      manualQCReviewRequest.qcReviewsForNumberReadsMap = numberReads;
    }

    if(qcReviewMode == 'metricsMerged'){
      let metricsMerged = {};
      this.mapOfQCReviewsForMetricsMerged.forEach((v: ResultMapperMetricsMerged, k:string) => metricsMerged[k]=v);
      manualQCReviewRequest.qcReviewsForMetricsMergedMap = metricsMerged;
    }

    manualQCReviewRequest.labId = this.selectedLabId;
    manualQCReviewRequest.batchId = this.selectedBatch.batchID;
    this.blocked = true;
    this.apgTestingService.saveManualQCReviews(manualQCReviewRequest).subscribe(
      result=>{
        this.selectedBatch = result.data;
        this.createPlateMaps(this.selectedBatch.samples);
        qcReviewMode == "numberReads" ? this.mapOfQCReviewsForNumberReads.clear() : this.mapOfQCReviewsForMetricsMerged.clear();
        this.blocked = false;
        if(qcReviewMode == "numberReads")
          this.manualQCReviewMode = false;
        else
          this.manualQCReviewMode2 = false;
        
        if(this.previousRadioValue === 'Batch QC Report'){
            this.getBatchViewForQCReport(this.selectedBatch.lab, this.selectedBatch.batchID);
        }
        this.valueChange.emit({"dirtyChild":false});
      },
      error=>{
        this.handleError(error);
      }
    )
  }

  private handleError(error: any) {
    this.blocked = false;
    let message = this.errorHandler.handleError(error);
    this._messagesService.addErrorMessage(message);
  }

  onManualQCReviewOff(event, qcReviewMap: Map<string, any>, qcReviewMode: string){
    if(!event.checked && Array.from(qcReviewMap.keys()).length > 0){
      this.confirmationService.confirm({
        message: "You've disabled the manual qc review mode without saving the changes. Click <b>Reject</b> to close the manual qc review mode without any changes. Click <b>Save</b> to store the changes.",
        acceptLabel: 'Save',
        rejectLabel: 'Reject',
        header: 'Warning',
        icon: 'pi pi-exclamation-triangle',
        key: "warningForChange",
        accept: () => {
          this.saveQCReviews(qcReviewMode);
        },
        reject: () => {
          qcReviewMap.clear();
          this.valueChange.emit({"dirtyChild":false});
         }
      })
    }
  }

  disableSaveQCForMetricsMerged(){
    return !(this.manualQCReviewMode2 && Array.from(this.mapOfQCReviewsForMetricsMerged.keys()).length !== 0);
  }
  getPangolianPieChartData(){
    this.selectedBatch.samples.forEach(sample => {
      let results: ResultPangolianMapper[] = sample.linageClassification;
      let lastResult: ResultPangolianMapper = results[results.length - 1];
     
      if(lastResult!=null && lastResult.status!='fail' && lastResult.linage!='NA'){
        if(this.pangolianPieData.get(lastResult.linage)!=null){
          const pieData=this.pangolianPieData.get(lastResult.linage);
          pieData.value=pieData.value+1;
          this.pangolianPieData.set(pieData.name,pieData);
        }else{
          const pieData=new PangolianPieModel();
          pieData.name=lastResult.linage;
          pieData.value=1;
          this.pangolianPieData.set(pieData.name,pieData);
        }
      }
      if(lastResult.status=='fail'){
        if(this.pangolianPieData.has("qc failed")){
          const pieData=this.pangolianPieData.get("qc failed");
          pieData.value=pieData.value+1;
          this.pangolianPieData.set(pieData.name,pieData);
        }else{
          const pieData=new PangolianPieModel();
          pieData.name="qc failed";
          pieData.value=1;
          this.pangolianPieData.set(pieData.name,pieData);
        }
      }
    });
    if(this.pangolianPieData.has("qc failed")){
      let qcData=this.pangolianPieData.get("qc failed");
      this.pangolianPieData.delete("qc failed")
      this.pangolianPieData.set("qc failed",qcData);
    }
    this.pangolianPieData.forEach((value: PangolianPieModel, key: string) => {
    this.pangoliandata.push(value);
  });
    this.sortPangolinDataAlphaNumerically();
  }

  private sortPangolinDataAlphaNumerically() {
   this.pangoliandata.sort((d1, d2) => {
      if (d1.name < d2.name)
        return -1;
      else if (d1.name > d2.name)
        return 1;

      else
        return 0;
    });
  }

  downloadPangolianTextFile(){
    var folderPath=this.getFolderPath(this.selectedBatch.pangolianTextFilePath);
    this.apgTestingService.downloadSecondaryAnalysisFile(folderPath,this.pangolianTextFileName).subscribe( 
        result => {
          var blob = new Blob([result.body], { type: 'txt' });
          if(blob.size!=0){
            this.saveFile(blob, this.pangolianTextFileName);
            this._messagesService.addSuccessMessage({
              severity: 'success', summary: 'Download is successful',
              detail: 'Secondary Analysis pangolian text file has been downloaded',
            });
          }else{
            this._messagesService.addErrorMessage({
              severity: 'error', summary: 'Download Failed',
              detail: 'Secondary Analysis pangolian text file has been deleted',
            });
          }
        },
        error => {
          this._messagesService.addErrorMessage({
            severity: 'error', summary: 'Download Failed',
            detail: 'Could not download text file',
          });
        }
      )
  }

  mutationRowSelection(i, j){
    let positionString = this.getRowColStringFromPos(i, j);
    if (this.plateMap.has(positionString)) {
      let sample = this.plateMap.get(positionString);
      if (sample && Object.keys(sample).length > 0 &&  sample.lastRunForMutationAnalysis== this.mutationRunId) {
        let results: MutationInfo[] = sample.mutationInfo;
        if(results!=undefined && results.length!=0){
          let lastResult: MutationCoverage[] = results[results.length - 1].mutationAnalysis;
          if(lastResult.length!=0){
            return "#a9a9a9";
          }
      }
      }
    }
  }


  getMutationData(i, j){
    let positionString = this.getRowColStringFromPos(i, j);
    if (this.plateMap.has(positionString)) {
      let sample = this.plateMap.get(positionString);
      if (sample && Object.keys(sample).length > 0 &&  sample.lastRunForMutationAnalysis== this.mutationRunId) {
        let results: MutationInfo[] = sample.mutationInfo;
        if(results!=undefined && results.length!=0){
          let lastResult: MutationCoverage[] = results[results.length - 1].mutationAnalysis;
          if(lastResult.length!=0){
            return lastResult;
          }
        }
      }
    }
  }


  getProcessedFilesData(){
    if(this.mutationProcessedData.has(this.mutationRunId)){
      let mutationFileCount=this.mutationProcessedData.get(this.mutationRunId);
      if(this.selectedBatch.samples.length!=undefined && this.selectedBatch.samples.length!=0){
        this.variantFilesProcessed=mutationFileCount+"/"+this.selectedBatch.samples.length;
      }
    }else{
      this.variantFilesProcessed=0+"/"+this.selectedBatch.samples.length;
    }
  }

  getToolTipForMutationData(i, j){
    let length=0;
    let sampleVar=this.getSampleAt(i, j, this.plateMap).barcode;
    let barCodeandMutationData;
    if(sampleVar.length>=19){
      let sampleBarCode= sampleVar.substr(0,19);
      let sampleBarCode1=sampleVar.substr(19,sampleVar.length-1);
      barCodeandMutationData='Barcode: '+ '\r\n' +sampleBarCode+ '\r\n' +sampleBarCode1+'\r\n';
    }else{
      barCodeandMutationData='Barcode: '+ '\r\n' + sampleVar+ '\r\n' ;
    }
    let mutationSampleData='';
    let resultofMutationData=this.getMutationData(i,j);
    if(resultofMutationData!=undefined && resultofMutationData.length!=0){
      resultofMutationData.forEach(mutationData=>{
      length=length+1;
      mutationSampleData=mutationSampleData+'\r\n'+mutationData.mutation+' - '+mutationData.frequency;})
    } 
      if(length!=0){
        barCodeandMutationData=barCodeandMutationData+'\r\n'+'PC mutants: '+length+"/3"+mutationSampleData;
      }
      return barCodeandMutationData;
  }

  getMutationRecentDate(sample:CovidSamples){
    if(sample.lastImportedDateTimeForMutationAnalysis && sample.lastRunForMutationAnalysis){
     
      if(this.mutationProcessedData.has(sample.lastRunForMutationAnalysis)){
        let value=this.mutationProcessedData.get(sample.lastRunForMutationAnalysis);
        this.mutationProcessedData.set(sample.lastRunForMutationAnalysis,value+1)
      }else{
        this.mutationProcessedData.set(sample.lastRunForMutationAnalysis,1);
      }
      
      if(new Date(sample.lastImportedDateTimeForMutationAnalysis).getTime()>=new Date(this.mutationRecentDate).getTime()){
        this.mutationRecentDate =sample.lastImportedDateTimeForMutationAnalysis;
        this.mutationRunId=sample.lastRunForMutationAnalysis;
      }
    }
  }

  getToolTipForSamples(i,j){
    let sampleVar=this.getSampleAt(i, j, this.plateMap).barcode;
    if(sampleVar.length>=19){
      let sampleBarCode= sampleVar.substr(0,19);
      let sampleBarCode1=sampleVar.substr(19,sampleVar.length-1);
      return 'Barcode: '+ '\r\n' +sampleBarCode+ '\r\n' +sampleBarCode1+'\r\n';
    }else{
      return 'Barcode: '+ '\r\n' + sampleVar;
    }
  }

  getColorsMap(){
    let count=0;
    this.selectedBatch.samples.forEach(sample => {
      let results: ResultPangolianMapper[] = sample.linageClassification;
      let lastResult: ResultPangolianMapper = results[results.length - 1];
      if(lastResult!=null){
        if(!this.pangolianPieColorMap.has(lastResult.linage) || lastResult.status == 'fail' ){
          if(lastResult.status=='fail'){
            this.pangolianPieColorMap.set("qc failed","#E88D8D");
          }
          if(lastResult.linage!='NA'){
            var randomColor=this.colorScheme.domain[count++];
            this.pangolianPieColorMap.set(lastResult.linage,randomColor);
          }
        }
      }
    });  
  }
 
  mutationRowSelectionBorderSolid(i, j){
    let positionString = this.getRowColStringFromPos(i, j);
    if (this.plateMap.has(positionString)) {
      let sample = this.plateMap.get(positionString);
      if (sample && Object.keys(sample).length > 0 &&  sample.lastRunForMutationAnalysis== this.mutationRunId) {
        let results: MutationInfo[] = sample.mutationInfo;
        if(results!=undefined && results.length!=0){
          let lastResult: MutationCoverage[] = results[results.length - 1].mutationAnalysis;
          if(lastResult.length!=0){
            return "thick";
          }
        }
      }
    }
  }

  customSort(event: SortEvent) {  
    event.data.sort((data1, data2) => {
        let value1 = data1[event.field];
        let value2 = data2[event.field];
        let result = null;

        if (value1 == null && value2 != null)
            result = -1;
        else if (value1 != null && value2 == null)
            result = 1;
        else if (value1 == null && value2 == null)
            result = 0;
        else if (event.field === 'positionRowAscii')
          result = value1.localeCompare( value2, undefined, { numeric: true } );
        else if (typeof value1 === 'string' && typeof value2 === 'string')
            result = value1.localeCompare(value2);
        else
            result = this.getSortResult(value1, value2);
        return (event.order * result);
    });
  }

  getSortResult(value1, value2){
      if(value1 < value2){
          return -1;
      }
      return (value1 > value2) ? 1 : 0;
  }

  getBatchViewForQCReport(lab:string , batchID:string) {
    this.blocked = true;
    this.mapOfQCBatchView.clear();
    this.batchQCView = [];
    this.apgTestingService.getBatchViewForQCReport(lab, batchID).subscribe(
      result => {
        if (result.data) {
          Object.entries(result.data).forEach(([key, value]) => {
            this.mapOfQCBatchView.set(key, value);
          });
          this.qcPassed = this.mapOfQCBatchView.get("qcPassed");
          this.qcMergeCount = this.mapOfQCBatchView.get("qcMergeCount");
          this.qcReadCount = this.mapOfQCBatchView.get("qcReadCount");
          Object.entries(this.mapOfQCBatchView.get("output")).forEach(([key, value]) => {   
          let firstsample: BatchQCView = JSON.parse(JSON.stringify(value));
          this.batchQCView.push(firstsample)
          });
        }
        this.blocked =false;
      },
      error => {
        this.handleError(error);
      }
    );
  }
  
  getBatchQCReport(event, value:string){
    this.previousRadioValue = value;
    this.manualQCReviewMode = false;
    this.manualQCReviewMode2 = false;
    if(Array.from(this.mapOfQCReviewsForNumberReads.keys()).length > 0 || Array.from(this.mapOfQCReviewsForMetricsMerged.keys()).length > 0){
        this.onManualQCReviewClicked(this.mapOfQCReviewsForNumberReads, 'numberReads');
        this.onManualQCReviewClicked(this.mapOfQCReviewsForMetricsMerged, 'metricsMerged');
    } else if(value === 'Batch QC Report'){
      this.getBatchViewForQCReport(this.selectedBatch.lab, this.selectedBatch.batchID);
    }
  }

  onManualQCReviewClicked(qcReviewMap: Map<string, any>, qcReviewMode: string){
    this.manualQCReviewMode = false;
    this.manualQCReviewMode2 = false;
    if(Array.from(qcReviewMap.keys()).length > 0){
      this.confirmationService.confirm({
        message: "You are leaving the manual qc review mode without saving the changes. Click Reject to close the manual qc review mode without any changes. Click Save to store the changes.",
        acceptLabel: 'Save',
        rejectLabel: 'Reject',
        header: 'Warning',
        key: "warningForChange",
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          this.saveQCReviews(qcReviewMode);
        },
        reject: () => {
          qcReviewMap.clear();
          this.valueChange.emit({"dirtyChild":false});
          if(this.previousRadioValue === 'Batch QC Report'){
            this.getBatchViewForQCReport(this.selectedBatch.lab, this.selectedBatch.batchID);
          }
         }
      })
    }
  }
  
  initializeConverterAssistMaps() {
    this.mapRowAdder.set("A1", 1);
    this.mapRowAdder.set("A2", 0);
    this.mapRowAdder.set("B1", 1);
    this.mapRowAdder.set("B2", 0);

    this.mapColAdder.set("A1", 1);
    this.mapColAdder.set("A2", 1);
    this.mapColAdder.set("B1", 0);
    this.mapColAdder.set("B2", 0);

    this.plateMap = new Map();

    this.mapOfA1 = new Map();
    this.mapOfA2 = new Map();
    this.mapOfB1 = new Map();
    this.mapOfB2 = new Map();

    this.quadrantBatchMap = new Map();
  }

  constructMidplexPlateMaps() {
    this.initializeConverterAssistMaps();
    
    this.val2 = !this.selectedBatch.snpResultUploadDateTime  ? 'Detail' : 'SNPResults';

    if(this.selectedBatch.wellType == 'WELL96') {
      this.plateViewData = this.selectedBatch.samples;
        this.plateMap = this.createMapOutOfCovidSamplesDifferentMap(this.plateViewData, this.plateMap, 0, 0, 1);
    } else if(this.selectedBatch.wellType == 'WELL384' && this.sourceBatchSamplesMap && this.sourceBatchSamplesMap.size > 0) {
      this.getSNPThresholdValueFromMDM();
      this.selectedBatch.mergedBatches.forEach(batch => {
        this.quadrantBatchMap.set(batch.quadrant, batch);
        let rowAdder = this.mapRowAdder.get(batch.quadrant);
        let colAdder = this.mapColAdder.get(batch.quadrant);
        this["mapOf" + batch.quadrant] = this.createMapOutOfCovidSamplesDifferentMap(this.sourceBatchSamplesMap.get(batch.batchId), this["mapOf" + batch.quadrant],  rowAdder, colAdder, 2);
      });
    } 
   
  }
  getSNPThresholdValueFromMDM() {
    this.masterDataService.getSNPThresHoldValueFromMDM(this.selectedBatch.product,this.selectedBatch.lab).subscribe(
      results => {  
        this.snpProfileThresholdValue=results.requiredPercentage;
      },
      error => {
       this.handleError(error);
      }
    );
  }

  getMidplexSampleBoxColor(barcode: string) {
    if(barcode.endsWith('_PC')) {
      return {'background-color' : 'aqua'}
    } else if(barcode.endsWith('_NTC')) {
      return {'background-color' : 'yellow'}
    } else if(barcode != '') {
      return {'background-color' : '#f0cced'}
    } else {
      return {};
    }
  }

  getSampleAtWrapper(row: number, col: number, quadrant: string) {
    return this.getSampleAt(row, col, this["mapOf" + quadrant]);
  }

  getBatchLabel(quadrant: string) {
    return quadrant + " : " + this.quadrantBatchMap.get(quadrant).batchId;
  }

  
  getMidplexSNPProfileSampleBoxColor1(row: number, col: number, quadrant: string){
      return this.getbackGroundColourForPanel1(row, col, this["mapOf" + quadrant]);
    
  }
 
  getbackGroundColourForPanel1(row: number, col: number, mapOfBatch: Map<string, CovidSamples>){
    let positionString = this.getRowColStringFromPos(row, col);
    if (mapOfBatch.has(positionString)) {
      if(mapOfBatch.get(positionString).snpDetailsView){
        return this.getMidplexSNPCOlour(mapOfBatch.get(positionString).snpDetailsView.p1TotalCount);
      }
    }
  }
  getMidplexSNPCOlour(panel:number){
    if( this.snpProfileThresholdValue <= panel ) {
      return {'background-color' : '#71ea71'}
    } else if(this.snpProfileThresholdValue > panel) {
      return {'background-color' : '#f37070'}
    }else {
      return {};
    }
 }
getSampleAtWrapperforSNp(row: number, col: number, quadrant: string) {
  return this.getSampleAtSNP(row, col, this["mapOf" + quadrant]);
}

getToolTipForSnp(row: number, col: number,quadrant: string) {
  return this.getSampleAtSNPFPrToolTip(row, col, this["mapOf" + quadrant]);
}
getSampleAtSNPFPrToolTip(row: number, col: number, mapOfBatch: Map<string, CovidSamples>) {
  let positionString = this.getRowColStringFromPos(row, col);
  if (mapOfBatch.has(positionString)) {
    if(mapOfBatch.get(positionString).snpDetailsView){
      return 'Barcode: ' +mapOfBatch.get(positionString).barcode;
    }
  }
  return '';
}
getSampleAtSNP(row: number, col: number, mapOfBatch: Map<string, CovidSamples>) {
  let positionString = this.getRowColStringFromPos(row, col);
  if (mapOfBatch.has(positionString)) {
    if(mapOfBatch.get(positionString).snpDetailsView){
      return mapOfBatch.get(positionString).snpDetailsView.p1TotalCount;
    }else{
      return '-';
    }
  }
  return '';
}
getSampleAtWrapperforSNpTotalPanel(row: number, col: number, quadrant: string) {
  return this.getSampleAtSNPForTotalPanel(row, col, this["mapOf" + quadrant]);
}
getSampleAtSNPForTotalPanel(row: number, col: number, mapOfBatch: Map<string, CovidSamples>) {
  let positionString = this.getRowColStringFromPos(row, col);
  if (mapOfBatch.has(positionString)) {
    if(mapOfBatch.get(positionString).snpDetailsView && mapOfBatch.get(positionString).snpDetailsView.sexDetermination){
       return mapOfBatch.get(positionString).snpDetailsView.totalCount+ "  ("+mapOfBatch.get(positionString).snpDetailsView.sexDetermination+")";
    }else if(mapOfBatch.get(positionString).snpDetailsView){
       return mapOfBatch.get(positionString).snpDetailsView.totalCount+ "  (-)";
    }else{
       return '-';
    }
}
  return '';
}
}
